export type Language = 'en' | 'es' | 'fr' | 'ru'

export const translations: Record<Language, any> = {
  en: {
    common: {
      backToMain: 'Back to danceforfans.com',
      backToMainStage: 'Back to the main stage',
      conceptInProgress: 'Concept in progress',
      contact: 'Contact',
    },
    hero: {
      badge: 'Concept in progress',
      subBadge: '"If we build it, they will Cum"',
      future: '2026 future',
      tagline: 'A platform in motion.',
      contactBtn: 'Contact us',
      callBtn: 'jose@danceforfans.com',
    },
    welcome: {
      titleStart: 'Welcome to ',
      titleHighlight: 'Dance for Fans',
      titleEnd: ' — the bold new platform giving OnlyFans a run for its money.',
      subtitle:
        'Your next-level destination for exclusive content, uniquely tailored for the ultimate fans.',
    },
    market: {
      opportunity: 'The opportunity',
      p1Start: 'OnlyFans launched in 2016 and crossed into ',
      p1Highlight: 'billion-dollar revenue',
      p1End:
        ' by 2020 — a meteoric four-year rise built on the creator economy and direct-to-consumer demand.',
      cards: [
        {
          title: '2016',
          desc: 'Launched as a subscription-based platform for creators.',
        },
        {
          title: '$1B+',
          desc: 'Revenue range crossed by 2020 — just four years in.',
        },
        {
          title: 'D2C',
          desc: 'Direct-to-consumer creator economy still expanding.',
        },
      ],
      p2Start:
        'The market is proven, the demand is global, and the playbook is open. ',
      p2Highlight: 'Dance for Fans',
      p2End:
        ' is positioned to enter that same wave — with a sharper, dance-first identity.',
    },
    ctas: {
      competitors: {
        tag: "See who's playing the game",
        title: 'Curious about the competitors and their revenue?',
        btn: 'Click Here For Competitors And Their Revenue',
      },
      story: {
        tag: 'The origin story',
        title: 'How OnlyFans got started.',
        btn: 'Click Here For The Full Story',
      },
      launch: {
        tag: 'For builders & operators',
        title: 'Want to know how to launch a platform like this?',
        desc: "Hosting, infrastructure, scale, security — we've put together a deep dive on what it takes to run a platform like danceforfans.com.",
        btn: 'Click here for the launch guide',
      },
      idea: {
        tag: 'For potential investors',
        title: 'Want to hear our investment idea?',
        btn: 'Click Here For Investment Breakdown',
      },
      expectations: {
        tag: 'For dancers',
        title:
          "What's expected from dancers, and what should dancers expect from Dance for Fans?",
        btn: 'Click Here For Expectations',
      },
      agreement: {
        tag: 'The Partnership Agreement',
        title: 'See what a partnership with Dance for Fans looks like.',
        subtitle: "Here you will also find Q and A's.",
        btn: 'Click Here For What An Agreement Looks Like With Dance For Fans',
      },
    },
    agreementPage: {
      headerTag: 'The Partnership Agreement',
      heroTag: '✦ Investor & Dancer Partnership Agreement ✦',
      heroTitle: 'What an agreement with Dance for Fans looks like.',
      heroSubtitle:
        'A plain-language preview of how dancers become true partners in the platform.',
      sections: [
        {
          title: 'Introduction',
          paragraphs: [
            'For just a low fee of $2,500, you will own 0.049% of the total share with Dance for Fans. This makes you both a creator and a partner in the platform\u2019s success.',
          ],
        },
        {
          title: 'Investor Role and Ownership',
          paragraphs: [
            'We\u2019re looking for either:\n\n\u2022 1,000 dancers at $2,500 each, owning 0.049% each, or\n\u2022 2,000 dancers at $1,250 each, owning 0.0245% each.\n\nAll together, this makes up the total 49% investor pool.',
          ],
        },
        {
          title: 'Revenue Distribution',
          paragraphs: [
            'As soon as Dance for Fans starts running, your distribution kicks in right away. Whatever your share is \u2014 for example, 0.049% \u2014 you start receiving your take-home from the very beginning. Whether the site is making $1 million a month or $20 million a month, your share starts paying out immediately.',
          ],
        },
        {
          title: 'Investor Expectations',
          paragraphs: [
            'To keep your share in good standing, each investor must dedicate at least 33 hours a month to the platform \u2014 whether that\u2019s creating content, engaging with fans, or promoting. As a reward for being an early investor, instead of the regular 20% cut, your payout cut is only 15%.',
          ],
        },
        {
          title: 'Term Length and Exit Strategy',
          paragraphs: [
            'The term length is as long as you remain active. As long as you\u2019re contributing 33 hours a month, you maintain full ownership of your share.',
            'If you ever want to exit, you can sell your share, but only to the next top dancer waiting in line. The sale must be at cost, up to one year\u2019s worth of your income at that time.',
            'For example, if your share is making $50,000 a month, you could sell your share for up to $600,000. This keeps everything fair and aligned with the platform\u2019s growth.',
          ],
        },
        {
          title: 'Legal Protections',
          paragraphs: [
            'No hidden agendas \u2014 everything is black and white. Investors are the sole owners of their share. Like owning property, that share belongs fully to them. Unlike real estate, they don\u2019t have to pay taxes, marketing, management, or operational fees. God forbid, if there\u2019s an accident or they can\u2019t perform, they keep their share until they recover.',
          ],
        },
        {
          title: 'Signatures and Agreement',
          paragraphs: [
            'Upon signing, everything goes into a corporate account, and site development begins. The expected startup time is approximately 6 to 12 months.',
          ],
        },
      ],
      qaTitle: 'Questions Already Asked by Dancers',
      qaSubtitle:
        'These are questions submitted out of curiosity into the page.',
      qa: [
        {
          q: 'When do I get paid, and how often?',
          a: 'Payouts start from day one. There is no waiting period to unlock earnings \u2014 you keep your share as it comes in. The split is laid out in Section 3.',
        },
        {
          q: 'Do I have to show my face?',
          a: 'No. Many performers use masks, lighting, or framing to keep their identity private. Your boundaries are yours to set, and the platform supports them.',
        },
        {
          q: 'What happens if a fan crosses a line?',
          a: 'Safety is the first rule. You can block, mute, or report any fan at any time. We take harassment seriously and act on it quickly.',
        },
        {
          q: 'Am I locked into a long contract?',
          a: 'No long-term lockup. Section 5 covers term and exit \u2014 you can leave with reasonable notice. We earn your loyalty, we do not enforce it.',
        },
        {
          q: 'Who owns my content?',
          a: 'You do. Dance for Fans licenses your content to host and distribute it on the platform \u2014 full ownership stays with you.',
        },
        {
          q: 'Will AI be allowed to be used in Dance for Fans?',
          a: 'No, AI bots will not be allowed. If we catch anyone using AI or bots, we will block that IP address and prevent them from ever using the site again.',
        },
        {
          q: 'If we\u2019re investing, why do we still have to login for the 33 hours a month?',
          a: 'Corporate and customer service will be working nonstop behind the scenes. As an investor, contributing 33 hours a month helps keep engagement high and builds the community. In the end, your share is yours alone, and all the returns go directly to you. We\u2019re not asking for extra payments for corporate operations, overhead, or bills \u2014 just your time and passion to help the platform thrive.',
        },
        {
          q: 'As an investor, do we have access to the financials, and how will we get that information?',
          a: 'You will not have access to all the financials, as that\u2019s handled by corporate, but you will get a weekly report showing exactly how much money came in \u2014 whether on a Monday or Friday \u2014 so you\u2019ll always know how the platform is performing.',
        },
        {
          q: "What's the difference between Dance for Fans and OnlyFans?",
          a: 'Dance for Fans is built on partnership. Not only do dancers create content, but they also become investors with a real stake in the platform. We offer a main showroom for dancers to showcase live performances and attract new followers. Plus, we emphasize a safe, supportive community and lower overall payout cuts for early investors.',
        },
      ],
      closing:
        'A real agreement, written by counsel, will follow this same spirit \u2014 fair, transparent, and built around partnership.',
      draftNotice: 'Preview draft \u00b7 Not a binding contract',
      footerTag: 'danceforfans.com \u00b7 The Partnership Agreement',
    },
    expectationsPage: {
      headerTag: 'The Stage Contract',
      heroTag: '✦ The expectations ✦',
      heroTitle: "What's expected from dancers.",
      heroSubtitle:
        'Dance for Fans is built on partnership. Here is what we ask of every dancer who steps on stage with us.',
      items: [
        {
          title: 'Safety first.',
          desc: "Women's safety is the top priority in Dance for Fans. Stay online, avoid meeting up with anyone in person, and always prioritize your well-being.",
        },
        {
          title: 'Create regular, engaging content.',
          desc: 'Dance routines, behind-the-scenes clips, tutorials, or interactive sessions — keep the stage alive and your audience coming back.',
        },
        {
          title: 'Promote your profile and the platform.',
          desc: 'Help build a strong community by sharing your profile and Dance for Fans across your channels and networks.',
        },
        {
          title: 'Engage with fans directly.',
          desc: 'Foster loyalty and drive subscriptions by connecting with fans, responding to messages, and making them feel seen.',
        },
        {
          title: 'Collaborate with other dancers.',
          desc: 'Team up with other dancers to create special content, joint streams, or events that grow the whole community.',
        },
        {
          title: 'Be a true partner.',
          desc: "Don't just earn from your content — share in the platform's success. We're building this together.",
        },
      ],
      platformTag: 'In return',
      platformTitle: 'What Dancers Should Expect from Dance for Fans',
      platformItems: [
        {
          title: 'Transparent and fair payouts.',
          desc: 'Clear, on-time payments starting from day one. No hidden fees, no surprises — what you earn is what you get.',
        },
        {
          title: 'Monthly bonuses for top performers.',
          desc: 'We value all dancers — there will be monthly bonuses for top earners and those most involved in online engagement with customers.',
        },
        {
          title: 'A yearly paid vacation reward.',
          desc: 'Every year, the most active dancers — especially those consistently engaging — will get a paid vacation reward.',
        },
        {
          title: 'A real voice in the platform.',
          desc: 'We value all input — that\u2019s why we have over a thousand dancer-performers as investors, to listen and stay connected to what really matters.',
        },
        {
          title: 'A real stage in the main showroom.',
          desc: 'Unlike other sites, we will have a main showroom where dancers get 15 to 20 minutes of actual live, on-stage time. This gives customers a chance to see you in action, and it can attract them to your page and your private settings, driving more engagement and followers.',
        },
      ],
      closing:
        "These aren't rules — they're the rhythm of the platform. When dancers show up, the whole stage lights up.",
      footerTag: 'danceforfans.com · The Stage Contract',
    },
    vision: {
      p1: "Dance for Fans is an up-and-coming platform for adults 18+, focused on sensual and expressive dance. It's perfect for couples—think dirty dancing couples—and single men and women who want to share their art. We also proudly welcome the LGBTQ+ community.",
      p2: 'Dance for Fans will have a main showroom where every dancer signs up on a waiting list to get their opportunity to be on the main stage. Couples, singles, and all performers get the chance to showcase live, helping them find the customers and fans that resonate with them and follow them to their private pages.',
      p3Start:
        "It's adult entertainment that celebrates bold creativity, intimacy, and connection, giving performers the chance to shine and attract fans who appreciate their work.",
      p3Highlight: '',
    },
    sections: {
      title: 'Two stages. One community.',
      subtitle:
        "We're committed to empowering creators from all backgrounds. That's why we envision two distinct sections, ensuring each performer reaches the right audience.",
      openFloor: {
        title: 'Open Floor',
        desc: 'For general dance creators and all styles. A space dedicated to the art of movement, from contemporary to hip-hop, ballet to breakdance.',
        bullets: [
          'All ages welcome',
          'Flexible monetization tools',
          'Supportive community',
        ],
      },
      afterHours: {
        tag: '18+ ONLY',
        title: 'After Hours',
        desc: 'For those who explore adult content. A tasteful, secure environment ensuring performers reach the right audience for more mature avenues of expression.',
        bullets: [
          'Age-gated environment',
          'Premium monetization',
          'Discreet & secure',
        ],
      },
    },
    join: {
      tag: 'Join from the ground up',
      title: 'Want in on Dance for Fans?',
      subtitle:
        "If you're interested in joining at the ground level, drop your info below and we'll reach out.",
      q1: "What's your Instagram handle?",
      q2: "What's your age? (18+)",
      q3: "What's your experience in content creation?",
      q3Placeholder: 'Tell us about your background, platforms, style…',
      q4: 'How many followers do you currently have across platforms?',
      q4Placeholder: 'e.g. 12k on IG, 3k on TikTok',
      q5: 'Best way to reach you and any questions you have, here.',
      q5Placeholder: 'What would make this platform a hit?',
      btn: 'Click Here',
    },
    domain: {
      title: 'Shape the future.',
      descStart: 'This concept is still in the thought process. The home is ',
      descHighlight: 'danceforfans.com',
      descEnd: '.',
      directContact: 'Direct Contact',
      askForStart: 'Email us at ',
      askForHighlight: 'jose@danceforfans.com',
      askForEnd: ' to discuss acquiring this domain and concept.',
    },
    visit: {
      counting: 'Counting visits…',
      visits: 'visits',
    },
    launchPage: {
      headerTag: 'The Backstage',
      heroTag: '✦ Velvet curtain · Backstage pass ✦',
      heroTitleStart: 'How to launch a platform like ',
      heroTitleHighlight: 'Dance for Fans',
      heroTitleEnd: '.',
      heroDesc:
        "Welcome backstage. Before the spotlight hits, every great show needs scaffolding — power, lighting, security, a stage that won't buckle when the crowd shows up. Here's what it takes.",
      intro1:
        "For hosting, you'll need a provider that can handle large file uploads, secure payments, and high traffic.",
      intro2:
        "Let's dive into the details — these are the top choices for an operation like this.",
      providers: [
        {
          name: 'Amazon Web Services (AWS)',
          tag: 'Most flexible · Recommended',
          desc: 'Highly scalable with services like EC2 for hosting your app, S3 for storing media files, and CloudFront as a CDN. AWS also offers excellent security features and compliance tools out of the box.',
          bullets: [
            'EC2 compute & auto-scaling',
            'S3 for media storage',
            'CloudFront CDN',
            'IAM, KMS & compliance tools',
          ],
        },
        {
          name: 'Google Cloud Platform (GCP)',
          tag: 'Most flexible · Recommended',
          desc: 'Similar to AWS in scale and capability — secure storage, strong compute, world-class analytics, and seamless integration with the rest of the Google ecosystem.',
          bullets: [
            'Cloud Storage & Compute Engine',
            'Strong analytics (BigQuery)',
            'Global CDN',
            'ML/AI ready',
          ],
        },
        {
          name: 'Microsoft Azure',
          tag: 'Enterprise-grade',
          desc: 'Powerful, with enterprise-level security, deep compliance features, and global data centers for low-latency performance worldwide.',
          bullets: [
            'Enterprise compliance',
            'Global data centers',
            'Hybrid cloud support',
            'Strong identity tooling',
          ],
        },
        {
          name: 'DigitalOcean',
          tag: 'Simple to start',
          desc: 'Simpler and more straightforward — great for smaller-scale projects that need room to scale later. Managed databases, storage, and easy-to-deploy droplets.',
          bullets: [
            'Managed databases',
            'Spaces object storage',
            'Predictable pricing',
            'Friendly developer UX',
          ],
        },
        {
          name: 'Vultr / Linode',
          tag: 'Cost-effective VPS',
          desc: "High-performance virtual private servers. Cost-effective and great if you want more control and don't mind managing infrastructure yourself.",
          bullets: [
            'Cheap, fast VPS',
            'Global regions',
            'Full root control',
            'Good for lean teams',
          ],
        },
      ],
      bottomTag: 'The bottom line',
      bottomTitleStart:
        'For a project like Dance for Fans — heavy on media, heavy on traffic — ',
      bottomTitleHighlight: 'AWS or GCP',
      bottomTitleEnd: ' are the most flexible, scalable choices.',
      bottomDesc:
        "They give you room to grow, with all the tools you need: storage, security, performance, and even machine learning when you're ready to add advanced features.",
      footerTag: 'danceforfans.com · The Backstage',
    },
    competitorsPage: {
      headerTag: 'The Money Floor',
      heroTag: '✦ Follow the money ✦',
      heroTitleStart: 'Competitors & their ',
      heroTitleHighlight: 'revenue',
      heroTitleEnd: '.',
      heroDesc:
        "The market is real, and the numbers tell the story. Here's the incumbent that built this category — and the seven biggest names chasing them.",
      incumbentTag: 'The incumbent',
      incumbentSubTag: 'Market leader',
      incumbentName: 'The "Only for Fans" Incumbent',
      incumbentDesc:
        'OnlyFans launched in 2016 as a subscription-based platform for creators to share content directly with their fans. It saw rapid growth, crossing into the billion-dollar revenue range by 2020, as it tapped into the growing creator economy and the demand for exclusive content. This meteoric rise took roughly four years, driven by its unique business model and the shift toward direct-to-consumer digital services.',
      incumbentRevLabel: 'Annual Revenue',
      incumbentRevVal: '$1B+',
      incumbentRevSub: 'by 2020 · just 4 years in',
      top7Tag: 'The Top 7 Competitors',
      estRevLabel: 'Est. Revenue',
      competitors: [
        {
          name: 'Patreon',
          rev: '~$160M / year',
          desc: 'One of the biggest competitors, focused on creator subscriptions across all kinds of content.',
        },
        {
          name: 'Fansly',
          rev: '~$50M – $100M / year',
          desc: 'Growing fast, and estimated to be bringing in around fifty to one hundred million a year.',
        },
        {
          name: 'FanCentro',
          rev: '~$20M – $40M / year',
          desc: 'A well-established platform in the creator economy, estimated around twenty to forty million annually.',
        },
        {
          name: 'AVN Stars',
          rev: '~$10M – $20M / year',
          desc: 'Connected with the AVN brand, likely bringing in around ten to twenty million per year.',
        },
        {
          name: 'JustFor.Fans',
          rev: '~$5M – $15M / year',
          desc: 'A niche platform, estimated around five to fifteen million annually.',
        },
        {
          name: 'Unlockd',
          rev: '~$3M – $10M / year',
          desc: 'A newer player in the space, estimated around three to ten million per year.',
        },
        {
          name: 'IsMyGirl',
          rev: '~$2M – $5M / year',
          desc: 'Smaller, but still notable in the niche — estimated around two to five million annually.',
        },
      ],
      bottomTag: 'The bottom line',
      bottomTitleStart: 'A category worth ',
      bottomTitleHighlight: 'billions',
      bottomTitleEnd:
        ' — and the runner-ups alone are pulling hundreds of millions a year.',
      bottomDescStart: '',
      bottomDescHighlight: 'Dance for Fans',
      bottomDescEnd:
        ' enters this market with a sharper identity, a dedicated audience, and clear room to grow.',
      footerTag: 'danceforfans.com · The Money Floor',
    },
    storyPage: {
      headerTag: 'The Archive',
      heroTag: 'Chapter zero',
      heroTitleStart: 'From zero to ',
      heroTitleHighlight: 'billions',
      heroTitleEnd: '.',
      heroDescStart: 'In just ',
      heroDescHighlight: '10 years',
      heroDescEnd:
        ", OnlyFans went from a £10,000 loan to a global creator-economy phenomenon. Here's how.",
      chapters: [
        {
          year: '2016',
          title: 'A family-backed bet.',
          body: "The platform's founder, Tim Stokely, launched the site with the initial support of his family. He reportedly borrowed around £10,000 from his father, Guy Stokely, to get the site off the ground. That early funding covered development and early marketing costs, allowing the platform to slowly attract its first wave of content creators — a quiet beginning to what would become a category-defining business.",
        },
        {
          year: '2017 – 2018',
          title: 'Momentum and a majority stake.',
          body: 'By 2017 and 2018, the platform had started gaining real momentum. It attracted influencers from various industries, and its subscription model resonated with creators looking for direct monetization. In 2018, Leonid Radvinsky — known for his experience in adult entertainment platforms — purchased a 75% stake in the company. His involvement brought significant investment and business acumen, helping professionalize operations and expand outreach.',
        },
        {
          year: '2019 – 2021',
          title: 'The explosion.',
          body: 'From 2019 onward, the platform exploded in popularity. The creator base diversified — influencers, musicians, fitness coaches, and adult entertainers all flocked to it. The COVID-19 pandemic further accelerated its growth, as many creators turned to online platforms for income. By 2020 and 2021, it had become a global phenomenon, with millions of users and billions in payouts to creators.',
        },
      ],
      summaryTag: 'In short',
      summaryText:
        'It started as a bold, family-backed venture in 2016, grew steadily with key investments by 2018, and then skyrocketed into a global powerhouse by 2020 — revolutionizing creator monetization and redefining digital content subscription models worldwide.',
      footerTag: 'danceforfans.com · The Archive',
    },
    investorsPage: {
      headerTag: 'The Investor Floor',
      heroTag: '✦ A unique opportunity ✦',
      heroTitleStart: 'Own a piece of ',
      heroTitleHighlight: 'Dance for Fans',
      heroTitleEnd: '.',
      p1: "Welcome investors! Dance for Fans is offering a unique opportunity to own part of our platform. We're selling 49% of the company.",
      twoPathsTitle: 'Two paths to ownership.',
      p2: "We're considering two paths. Option one: a few larger investors, each owning a big share. Option two: 1,000 women — dancers or supporters — each investing $2,500.",
      option1Tag: 'Path 1',
      option1Title: 'A few large investors.',
      option1Desc:
        'A small group of strategic partners, each owning a substantial share of the company. Faster to close, fewer voices at the table.',
      option2Tag: 'Path 2 · Featured',
      option2Title: '1,000 women × $2,500.',
      option2Desc:
        'A community-powered model — 1,000 dancers or supporters each investing $2,500. Built-in advocates, shared upside, broad ownership.',
      mathTag: 'The math',
      mathTitle: 'How the numbers add up.',
      stat1: 'Investors at $2,500 each',
      stat2: 'Per-investor ticket size',
      stat3: 'Total raised',
      stat4: 'Equity offered',
      p3: 'In the second model, if 1,000 women invest $2,500 each, that brings in $2.5 million total. That $2.5 million represents the full 49% ownership stake.',
      p4Start: 'Each investor would own about ',
      p4Highlight: '0.049%',
      p4End: ' of the entire company.',
      upsideTag: 'The upside',
      upsideTitle: 'Where the numbers can go.',
      projMonthlyRevLabel: 'Company monthly revenue',
      projInvestorShareLabel: '49% investor share',
      projPerInvestorLabel: 'Per investor',
      projPerInvestorSub: 'monthly · 0.049% share',
      p5: "If the company grows to $20 million a month in revenue, that 49% would equal $9.8 million monthly. Each investor's share could potentially yield around $9,800 a month.",
      bigUpsideTag: 'And if it scales further',
      bigUpsideP:
        "We've already seen how fast OnlyFans grew to $166 million a month in under four years. Now, look at the math: when Dance for Fans makes it to that level, 49% for the investors means about $81.3 million a month. With 1,000 investors, that's around $81,300 per month each. That's the power of this model.",
      whyOption2Tag: 'Why option two',
      whyOption2Title: 'Why Option Two Is the Strongest Choice',
      whyOption2Subtitle: 'Dancers as investors. Investors as dancers.',
      whyOption2Intro1:
        'Option two stands out because it turns the people who power the platform into true partners in its success. Instead of dancers simply using the platform, they become invested in building it, growing it, and promoting it. That creates a much deeper level of loyalty, ownership, and long-term commitment than a traditional model ever could.',
      whyOption2Intro2:
        'When creators have a stake in the business, their mindset changes. They are no longer just participants — they become ambassadors, advocates, and growth drivers. That kind of alignment is incredibly powerful.',
      whyOption2GrowthHeader: 'A built-in engine for faster growth',
      whyOption2GrowthP1:
        'Reaching major revenue milestones, including the path toward $20 million per month, becomes far more achievable when the investor base and the creator base are one and the same. Why? Because the people earning on the platform now have a direct incentive to help expand it.',
      whyOption2GrowthLead: 'They are motivated to:',
      whyOption2GrowthBullets: [
        'Create more',
        'Promote more',
        'Bring in others',
        'Actively help build the community',
      ],
      whyOption2GrowthP2:
        "That creates a network effect that can dramatically accelerate growth. Instead of relying only on outside marketing or passive users, option two builds a community of stakeholders who are financially and emotionally invested in the platform's success.",
      whyOption2ProvenHeader: 'The model is proven',
      whyOption2ProvenP:
        "We've already seen how quickly creator-driven platforms can scale when the right momentum is in place. A fan-subscription platform like OnlyFans reached massive monthly revenue in just a few short years because creators fueled both adoption and retention. That same kind of momentum can be even more powerful here when the creators are not only earning on the platform, but also participating in its upside.",
      whyOption2MattersHeader: 'Why this matters',
      whyOption2MattersP1:
        'Option two is not just a funding strategy — it is a growth strategy. It creates stronger loyalty, faster expansion, and a community that is motivated to win together.',
      whyOption2MattersP2:
        "That's what makes option two the best choice: it aligns ownership with contribution, and it turns growth into a shared mission.",
      disclaimer:
        'These figures are illustrative projections meant to show the financial potential of the model. Actual results would depend on platform performance, market conditions, and many other factors. This is not an offer to sell securities.',
      contactBtn: 'Email jose@danceforfans.com',
      footerTag: 'danceforfans.com · The Investor Floor',
    },
  },
  es: {
    common: {
      backToMain: 'Volver a danceforfans.com',
      backToMainStage: 'Volver al escenario principal',
      conceptInProgress: 'Concepto en progreso',
      contact: 'Contacto',
    },
    hero: {
      badge: 'Concepto en progreso',
      subBadge: '"If we build it, they will Cum"',
      future: 'futuro 2026',
      tagline: 'Una plataforma en movimiento.',
      contactBtn: 'Contáctanos',
      callBtn: 'jose@danceforfans.com',
    },
    welcome: {
      titleStart: 'Bienvenido a ',
      titleHighlight: 'Dance for Fans',
      titleEnd:
        ' — la nueva y audaz plataforma que le da a OnlyFans una verdadera competencia.',
      subtitle:
        'Tu próximo destino para contenido exclusivo, diseñado de manera única para los verdaderos fans.',
    },
    market: {
      opportunity: 'La oportunidad',
      p1Start: 'OnlyFans se lanzó en 2016 y superó los ',
      p1Highlight: 'mil millones en ingresos',
      p1End:
        ' para 2020 — un ascenso meteórico de cuatro años basado en la economía de creadores y la demanda directa al consumidor.',
      cards: [
        {
          title: '2016',
          desc: 'Lanzada como una plataforma de suscripción para creadores.',
        },
        {
          title: '$1B+',
          desc: 'Rango de ingresos superado en 2020 — en solo cuatro años.',
        },
        {
          title: 'D2C',
          desc: 'La economía de creadores directa al consumidor sigue expandiéndose.',
        },
      ],
      p2Start:
        'El mercado está probado, la demanda es global y las reglas están claras. ',
      p2Highlight: 'Dance for Fans',
      p2End:
        ' está posicionada para entrar en esa misma ola — con una identidad más definida y centrada en el baile.',
    },
    ctas: {
      competitors: {
        tag: 'Mira quién está en el juego',
        title: '¿Curioso sobre los competidores y sus ingresos?',
        btn: 'Haz clic aquí para ver los competidores y sus ingresos',
      },
      story: {
        tag: 'La historia de origen',
        title: 'Cómo empezó OnlyFans.',
        btn: 'Haz clic aquí para ver la historia completa',
      },
      launch: {
        tag: 'Para constructores y operadores',
        title: '¿Quieres saber cómo lanzar una plataforma como esta?',
        desc: 'Alojamiento, infraestructura, escala, seguridad — hemos preparado un análisis profundo de lo que se necesita para operar una plataforma como danceforfans.com.',
        btn: 'Haz clic aquí para la guía de lanzamiento',
      },
      idea: {
        tag: 'Para inversores potenciales',
        title: '¿Quieres conocer nuestra idea de inversión?',
        btn: 'Haz clic aquí para el desglose de la inversión',
      },
      expectations: {
        tag: 'Para bailarinas',
        title:
          '¿Qué se espera de las bailarinas y qué deberían esperar las bailarinas de Dance for Fans?',
        btn: 'Haz clic aquí para las expectativas',
      },
      agreement: {
        tag: 'El Acuerdo de Asociación',
        title: 'Mira cómo es una asociación con Dance for Fans.',
        subtitle: 'Aquí también encontrarás preguntas y respuestas.',
        btn: 'Haz Clic Aquí Para Ver Cómo Es Un Acuerdo Con Dance For Fans',
      },
    },
    agreementPage: {
      headerTag: 'El Acuerdo de Asociación',
      heroTag: '✦ Acuerdo de Asociación Inversora y Bailarina ✦',
      heroTitle: 'Cómo es un acuerdo con Dance for Fans.',
      heroSubtitle:
        'Una vista previa en lenguaje claro de cómo las bailarinas se convierten en verdaderas socias de la plataforma.',
      sections: [
        {
          title: 'Introducción',
          paragraphs: [
            'Por solo una tarifa baja de $2,500, poseerás el 0,049% del total de acciones con Dance for Fans. Esto te convierte en creadora y socia del éxito de la plataforma.',
          ],
        },
        {
          title: 'Rol del Inversor y Propiedad',
          paragraphs: [
            'Buscamos:\n\n\u2022 1.000 bailarinas a $2.500 cada una, poseyendo 0,049% cada una, o\n\u2022 2.000 bailarinas a $1.250 cada una, poseyendo 0,0245% cada una.\n\nEn conjunto, esto compone el 49% total del fondo de inversoras.',
          ],
        },
        {
          title: 'Distribución de Ingresos',
          paragraphs: [
            'Tan pronto como Dance for Fans comience a funcionar, tu distribución se activa de inmediato. Sea cual sea tu participación \u2014 por ejemplo, 0,049% \u2014 empiezas a recibir tu parte desde el primer momento. Ya sea que el sitio esté generando $1 millón al mes o $20 millones al mes, tu parte comienza a pagarse de inmediato.',
          ],
        },
        {
          title: 'Expectativas de la Inversora',
          paragraphs: [
            'Para mantener tu participación en buen estado, cada inversora debe dedicar al menos 33 horas al mes a la plataforma \u2014 ya sea creando contenido, interactuando con fans o promoviendo. Como recompensa por ser inversora temprana, en lugar del corte habitual del 20%, tu corte de pago es solo del 15%.',
          ],
        },
        {
          title: 'Duración del Plazo y Estrategia de Salida',
          paragraphs: [
            'La duración del plazo es mientras permanezcas activa. Mientras contribuyas con 33 horas al mes, mantienes la propiedad total de tu participación.',
            'Si alguna vez quieres salir, puedes vender tu participación, pero solo a la siguiente bailarina destacada en la lista de espera. La venta debe ser al costo, hasta el equivalente de un año de tus ingresos en ese momento.',
            'Por ejemplo, si tu participación genera $50.000 al mes, podrías vender tu participación por hasta $600.000. Esto mantiene todo justo y alineado con el crecimiento de la plataforma.',
          ],
        },
        {
          title: 'Protecciones Legales',
          paragraphs: [
            'Sin agendas ocultas \u2014 todo está en blanco y negro. Las inversoras son las únicas propietarias de su participación. Como poseer una propiedad, esa participación les pertenece completamente. A diferencia de los bienes raíces, no tienen que pagar impuestos, marketing, gestión ni gastos operativos. Dios no lo quiera, si hay un accidente o no pueden actuar, conservan su participación hasta recuperarse.',
          ],
        },
        {
          title: 'Firmas y Acuerdo',
          paragraphs: [
            'Al firmar, todo va a una cuenta corporativa y comienza el desarrollo del sitio. El tiempo de inicio esperado es de aproximadamente 6 a 12 meses.',
          ],
        },
      ],
      qaTitle: 'Preguntas que ya hicieron las bailarinas',
      qaSubtitle:
        'Estas son preguntas enviadas por curiosidad a través de la página.',
      qa: [
        {
          q: '¿Cuándo cobro y con qué frecuencia?',
          a: 'Los pagos comienzan desde el primer día. No hay período de espera para desbloquear las ganancias \u2014 te quedas con tu parte a medida que llega. La división se detalla en la Sección 3.',
        },
        {
          q: '¿Tengo que mostrar mi cara?',
          a: 'No. Muchas artistas usan máscaras, iluminación o encuadres para mantener su identidad privada. Tus límites los pones tú, y la plataforma los respalda.',
        },
        {
          q: '¿Qué pasa si un fan cruza la línea?',
          a: 'La seguridad es la primera regla. Puedes bloquear, silenciar o reportar a cualquier fan en cualquier momento. Tomamos el acoso muy en serio y actuamos rápido.',
        },
        {
          q: '¿Estoy atrapada en un contrato largo?',
          a: 'No hay vínculo a largo plazo. La Sección 5 cubre el plazo y la salida \u2014 puedes irte con un aviso razonable. Ganamos tu lealtad, no la imponemos.',
        },
        {
          q: '¿Quién es dueña de mi contenido?',
          a: 'Tú. Dance for Fans solo licencia tu contenido para alojarlo y distribuirlo en la plataforma \u2014 la propiedad total sigue siendo tuya.',
        },
        {
          q: '¿Se permitirá el uso de IA en Dance for Fans?',
          a: 'No, los bots de IA no estarán permitidos. Si descubrimos a alguien usando IA o bots, bloquearemos esa dirección IP y le impediremos volver a usar el sitio.',
        },
        {
          q: 'Si estamos invirtiendo, ¿por qué aún tenemos que iniciar sesión las 33 horas al mes?',
          a: 'Corporativo y servicio al cliente trabajarán sin parar tras bambalinas. Como inversor, contribuir 33 horas al mes ayuda a mantener alto el engagement y construir la comunidad. Al final, tu parte es solo tuya, y todos los retornos van directamente a ti. No estamos pidiendo pagos adicionales por operaciones corporativas, gastos generales o facturas \u2014 solo tu tiempo y pasión para ayudar a que la plataforma prospere.',
        },
        {
          q: 'Como inversor, ¿tenemos acceso a las finanzas y cómo obtendremos esa información?',
          a: 'No tendrás acceso a todas las finanzas, ya que eso lo maneja corporativo, pero recibirás un informe semanal que muestra exactamente cuánto dinero entró \u2014 ya sea un lunes o un viernes \u2014 para que siempre sepas cómo está funcionando la plataforma.',
        },
        {
          q: '¿Cuál es la diferencia entre Dance for Fans y OnlyFans?',
          a: 'Dance for Fans está construida sobre la asociación. Las bailarinas no solo crean contenido, sino que también se convierten en inversoras con una participación real en la plataforma. Ofrecemos un salón principal para que las bailarinas muestren actuaciones en vivo y atraigan nuevos seguidores. Además, enfatizamos una comunidad segura y solidaria, y cortes de pagos generales más bajos para las primeras inversoras.',
        },
      ],
      closing:
        'Un acuerdo real, redactado por abogados, seguirá este mismo espíritu \u2014 justo, transparente y construido alrededor de la asociación.',
      draftNotice:
        'Borrador de vista previa \u00b7 No es un contrato vinculante',
      footerTag: 'danceforfans.com \u00b7 El Acuerdo de Asociación',
    },
    expectationsPage: {
      headerTag: 'El Contrato del Escenario',
      heroTag: '✦ Las expectativas ✦',
      heroTitle: 'Qué se espera de las bailarinas.',
      heroSubtitle:
        'Dance for Fans se construye sobre la colaboración. Esto es lo que pedimos de cada bailarina que sube al escenario con nosotros.',
      items: [
        {
          title: 'Seguridad primero.',
          desc: 'La seguridad de las mujeres es la máxima prioridad en Dance for Fans. Mantente en línea, evita reunirte con cualquier persona en persona y prioriza siempre tu bienestar.',
        },
        {
          title: 'Crear contenido regular y atractivo.',
          desc: 'Rutinas de baile, clips detrás de escena, tutoriales o sesiones interactivas — mantén el escenario vivo y a tu audiencia volviendo.',
        },
        {
          title: 'Promover tu perfil y la plataforma.',
          desc: 'Ayuda a construir una comunidad fuerte compartiendo tu perfil y Dance for Fans en tus canales y redes.',
        },
        {
          title: 'Interactúa directamente con los fans.',
          desc: 'Fomenta la lealtad y aumenta las suscripciones conectando con los fans, respondiendo a mensajes y haciéndolos sentir vistos.',
        },
        {
          title: 'Colabora con otras bailarinas.',
          desc: 'Únete a otras bailarinas para crear contenido especial, transmisiones conjuntas o eventos que hagan crecer a toda la comunidad.',
        },
        {
          title: 'Sé una verdadera socia.',
          desc: 'No solo ganes con tu contenido — comparte el éxito de la plataforma. Estamos construyendo esto juntas.',
        },
      ],
      platformTag: 'A cambio',
      platformTitle: 'Lo que las bailarinas deben esperar de Dance for Fans',
      platformItems: [
        {
          title: 'Pagos transparentes y justos.',
          desc: 'Pagos claros y puntuales desde el primer día. Sin tarifas ocultas, sin sorpresas — lo que ganas es lo que recibes.',
        },
        {
          title: 'Bonos mensuales para las mejores.',
          desc: 'Valoramos a todas las bailarinas — habrá bonos mensuales para las que más ganen y las más involucradas en la interacción online con los clientes.',
        },
        {
          title: 'Vacaciones pagadas cada año.',
          desc: 'Cada año, las bailarinas más activas — especialmente las que se mantienen interactuando constantemente — recibirán una recompensa de vacaciones pagadas.',
        },
        {
          title: 'Una voz real en la plataforma.',
          desc: 'Valoramos todas las opiniones — por eso tenemos más de mil bailarinas-artistas como inversoras, para escuchar y mantenernos conectadas con lo que realmente importa.',
        },
        {
          title: 'Un escenario real en la sala principal.',
          desc: 'A diferencia de otros sitios, tendremos una sala principal donde las bailarinas tendrán entre 15 y 20 minutos de tiempo real en el escenario en vivo. Esto le da a los clientes la oportunidad de verte en acción, y puede atraerlos a tu página y a tus configuraciones privadas, generando más interacción y seguidores.',
        },
      ],
      closing:
        'Estas no son reglas — son el ritmo de la plataforma. Cuando las bailarinas se presentan, todo el escenario se ilumina.',
      footerTag: 'danceforfans.com · El Contrato del Escenario',
    },
    vision: {
      p1: 'Dance for Fans es una plataforma emergente para adultos +18, enfocada en el baile sensual y expresivo. Es perfecta para parejas—piensa en parejas de dirty dancing—y para hombres y mujeres solteros que quieren compartir su arte. También damos la bienvenida con orgullo a la comunidad LGBTQ+.',
      p2: 'Dance for Fans tendrá un salón principal donde cada bailarín o bailarina se inscribe en una lista de espera para tener su oportunidad de estar en el escenario principal. Parejas, solteros y todos los artistas tienen la posibilidad de presentarse en vivo, ayudándoles a encontrar a los clientes y fans que conectan con ellos y los siguen a sus páginas privadas.',
      p3Start:
        'Es entretenimiento para adultos que celebra la creatividad audaz, la intimidad y la conexión, dando a los artistas la oportunidad de brillar y atraer a fans que aprecian su trabajo.',
      p3Highlight: '',
    },
    sections: {
      title: 'Dos escenarios. Una comunidad.',
      subtitle:
        'Estamos comprometidos a empoderar a creadores de todos los orígenes. Por eso visualizamos dos secciones distintas, asegurando que cada artista llegue a la audiencia adecuada.',
      openFloor: {
        title: 'Pista Abierta',
        desc: 'Para creadores de baile en general y todos los estilos. Un espacio dedicado al arte del movimiento, desde contemporáneo hasta hip-hop, ballet hasta breakdance.',
        bullets: [
          'Todas las edades bienvenidas',
          'Herramientas de monetización flexibles',
          'Comunidad de apoyo',
        ],
      },
      afterHours: {
        tag: 'SOLO 18+',
        title: 'Después de Horas',
        desc: 'Para aquellos que exploran contenido para adultos. Un entorno de buen gusto y seguro que asegura que los artistas lleguen a la audiencia adecuada para expresiones más maduras.',
        bullets: [
          'Entorno con restricción de edad',
          'Monetización premium',
          'Discreto y seguro',
        ],
      },
    },
    join: {
      tag: 'Únete desde el principio',
      title: '¿Quieres unirte a Dance for Fans?',
      subtitle:
        'Si te interesa unirte desde el principio, déjanos tu información a continuación y te contactaremos.',
      q1: '¿Cuál es tu usuario de Instagram?',
      q2: '¿Cuál es tu edad? (+18)',
      q3: '¿Cuál es tu experiencia en creación de contenido?',
      q3Placeholder: 'Cuéntanos sobre tu trayectoria, plataformas, estilo…',
      q4: '¿Cuántos seguidores tienes actualmente en todas las plataformas?',
      q4Placeholder: 'p. ej. 12k en IG, 3k en TikTok',
      q5: 'Mejor forma de contactarte y cualquier pregunta que tengas, aquí.',
      q5Placeholder: '¿Qué haría que esta plataforma sea un éxito?',
      btn: 'Haz clic aquí',
    },
    domain: {
      title: 'Da forma al futuro.',
      descStart:
        'Este concepto aún está en proceso de pensamiento. Su hogar es ',
      descHighlight: 'danceforfans.com',
      descEnd: '.',
      directContact: 'Contacto Directo',
      askForStart: 'Escríbenos a ',
      askForHighlight: 'jose@danceforfans.com',
      askForEnd: ' para discutir la adquisición de este dominio y concepto.',
    },
    visit: {
      counting: 'Contando visitas…',
      visits: 'visitas',
    },
    launchPage: {
      headerTag: 'El Backstage',
      heroTag: '✦ Cortina de terciopelo · Pase de backstage ✦',
      heroTitleStart: 'Cómo lanzar una plataforma como ',
      heroTitleHighlight: 'Dance for Fans',
      heroTitleEnd: '.',
      heroDesc:
        'Bienvenido al backstage. Antes de que se enciendan los focos, todo gran espectáculo necesita una estructura — energía, iluminación, seguridad, un escenario que no ceda cuando llegue la multitud. Esto es lo que se necesita.',
      intro1:
        'Para el alojamiento, necesitarás un proveedor que pueda manejar grandes cargas de archivos, pagos seguros y alto tráfico.',
      intro2:
        'Vamos a profundizar en los detalles — estas son las mejores opciones para una operación como esta.',
      providers: [
        {
          name: 'Amazon Web Services (AWS)',
          tag: 'Más flexible · Recomendado',
          desc: 'Altamente escalable con servicios como EC2 para alojar tu aplicación, S3 para almacenar archivos multimedia y CloudFront como CDN. AWS también ofrece excelentes funciones de seguridad y herramientas de cumplimiento desde el principio.',
          bullets: [
            'Cómputo EC2 y autoescalado',
            'S3 para almacenamiento multimedia',
            'CDN de CloudFront',
            'Herramientas IAM, KMS y cumplimiento',
          ],
        },
        {
          name: 'Google Cloud Platform (GCP)',
          tag: 'Más flexible · Recomendado',
          desc: 'Similar a AWS en escala y capacidad — almacenamiento seguro, cómputo potente, análisis de clase mundial e integración perfecta con el resto del ecosistema de Google.',
          bullets: [
            'Cloud Storage y Compute Engine',
            'Análisis potente (BigQuery)',
            'CDN global',
            'Listo para ML/AI',
          ],
        },
        {
          name: 'Microsoft Azure',
          tag: 'Nivel empresarial',
          desc: 'Potente, con seguridad de nivel empresarial, funciones de cumplimiento profundas y centros de datos globales para un rendimiento de baja latencia en todo el mundo.',
          bullets: [
            'Cumplimiento empresarial',
            'Centros de datos globales',
            'Soporte de nube híbrida',
            'Fuertes herramientas de identidad',
          ],
        },
        {
          name: 'DigitalOcean',
          tag: 'Fácil para empezar',
          desc: 'Más simple y directo — ideal para proyectos de menor escala que necesitan espacio para escalar más adelante. Bases de datos administradas, almacenamiento y servidores fáciles de implementar.',
          bullets: [
            'Bases de datos administradas',
            'Almacenamiento de objetos Spaces',
            'Precios predecibles',
            'UX amigable para desarrolladores',
          ],
        },
        {
          name: 'Vultr / Linode',
          tag: 'VPS rentable',
          desc: 'Servidores privados virtuales de alto rendimiento. Rentables e ideales si deseas más control y no te importa administrar la infraestructura tú mismo.',
          bullets: [
            'VPS rápido y económico',
            'Regiones globales',
            'Control root total',
            'Bueno para equipos pequeños',
          ],
        },
      ],
      bottomTag: 'En conclusión',
      bottomTitleStart:
        'Para un proyecto como Dance for Fans — con mucho contenido multimedia y alto tráfico — ',
      bottomTitleHighlight: 'AWS o GCP',
      bottomTitleEnd: ' son las opciones más flexibles y escalables.',
      bottomDesc:
        'Te dan espacio para crecer, con todas las herramientas que necesitas: almacenamiento, seguridad, rendimiento e incluso aprendizaje automático cuando estés listo para agregar funciones avanzadas.',
      footerTag: 'danceforfans.com · El Backstage',
    },
    competitorsPage: {
      headerTag: 'El Piso del Dinero',
      heroTag: '✦ Sigue el dinero ✦',
      heroTitleStart: 'Competidores y sus ',
      heroTitleHighlight: 'ingresos',
      heroTitleEnd: '.',
      heroDesc:
        'El mercado es real y los números cuentan la historia. Aquí está el titular que construyó esta categoría — y los siete nombres más grandes que los persiguen.',
      incumbentTag: 'El titular',
      incumbentSubTag: 'Líder del mercado',
      incumbentName: 'El Titular "Solo para Fans"',
      incumbentDesc:
        'OnlyFans se lanzó en 2016 como una plataforma de suscripción para que los creadores compartieran contenido directamente con sus fans. Experimentó un rápido crecimiento, superando el rango de mil millones de dólares en ingresos para 2020, al aprovechar la creciente economía de creadores y la demanda de contenido exclusivo. Este ascenso meteórico tomó aproximadamente cuatro años, impulsado por su modelo de negocio único y el cambio hacia servicios digitales directos al consumidor.',
      incumbentRevLabel: 'Ingresos Anuales',
      incumbentRevVal: '$1B+',
      incumbentRevSub: 'para 2020 · en solo 4 años',
      top7Tag: 'Los 7 Principales Competidores',
      estRevLabel: 'Ingresos Est.',
      competitors: [
        {
          name: 'Patreon',
          rev: '~$160M / año',
          desc: 'Uno de los mayores competidores, centrado en suscripciones de creadores en todo tipo de contenido.',
        },
        {
          name: 'Fansly',
          rev: '~$50M – $100M / año',
          desc: 'Creciendo rápido, y se estima que genera entre cincuenta y cien millones al año.',
        },
        {
          name: 'FanCentro',
          rev: '~$20M – $40M / año',
          desc: 'Una plataforma bien establecida en la economía de creadores, estimada en unos veinte a cuarenta millones anuales.',
        },
        {
          name: 'AVN Stars',
          rev: '~$10M – $20M / año',
          desc: 'Conectada con la marca AVN, probablemente genera alrededor de diez a veinte millones por año.',
        },
        {
          name: 'JustFor.Fans',
          rev: '~$5M – $15M / año',
          desc: 'Una plataforma de nicho, estimada en unos cinco a quince millones anuales.',
        },
        {
          name: 'Unlockd',
          rev: '~$3M – $10M / año',
          desc: 'Un jugador más nuevo en el espacio, estimado en unos tres a diez millones por año.',
        },
        {
          name: 'IsMyGirl',
          rev: '~$2M – $5M / año',
          desc: 'Más pequeña, pero aún notable en el nicho — estimada en unos dos a cinco millones anuales.',
        },
      ],
      bottomTag: 'En conclusión',
      bottomTitleStart: 'Una categoría que vale ',
      bottomTitleHighlight: 'miles de millones',
      bottomTitleEnd:
        ' — y solo los subcampeones están ganando cientos de millones al año.',
      bottomDescStart: '',
      bottomDescHighlight: 'Dance for Fans',
      bottomDescEnd:
        ' entra en este mercado con una identidad más definida, una audiencia dedicada y un claro espacio para crecer.',
      footerTag: 'danceforfans.com · El Piso del Dinero',
    },
    storyPage: {
      headerTag: 'El Archivo',
      heroTag: 'Capítulo cero',
      heroTitleStart: 'De cero a ',
      heroTitleHighlight: 'miles de millones',
      heroTitleEnd: '.',
      heroDescStart: 'En solo ',
      heroDescHighlight: '10 años',
      heroDescEnd:
        ', OnlyFans pasó de un préstamo de £10,000 a un fenómeno global de la economía de creadores. Así es cómo.',
      chapters: [
        {
          year: '2016',
          title: 'Una apuesta respaldada por la familia.',
          body: 'El fundador de la plataforma, Tim Stokely, lanzó el sitio con el apoyo inicial de su familia. Según los informes, pidió prestados alrededor de £10,000 a su padre, Guy Stokely, para poner en marcha el sitio. Esa financiación inicial cubrió los costos de desarrollo y marketing inicial, permitiendo que la plataforma atrajera lentamente a su primera ola de creadores de contenido — un comienzo tranquilo para lo que se convertiría en un negocio que definiría una categoría.',
        },
        {
          year: '2017 – 2018',
          title: 'Impulso y una participación mayoritaria.',
          body: 'Para 2017 y 2018, la plataforma había comenzado a ganar un impulso real. Atrajo a influencers de diversas industrias, y su modelo de suscripción resonó con creadores que buscaban monetización directa. En 2018, Leonid Radvinsky — conocido por su experiencia en plataformas de entretenimiento para adultos — compró una participación del 75% en la empresa. Su participación trajo una inversión significativa y perspicacia comercial, ayudando a profesionalizar las operaciones y expandir el alcance.',
        },
        {
          year: '2019 – 2021',
          title: 'La explosión.',
          body: 'A partir de 2019, la plataforma explotó en popularidad. La base de creadores se diversificó — influencers, músicos, entrenadores de fitness y artistas para adultos acudieron a ella. La pandemia de COVID-19 aceleró aún más su crecimiento, ya que muchos creadores recurrieron a plataformas en línea para obtener ingresos. Para 2020 y 2021, se había convertido en un fenómeno global, con millones de usuarios y miles de millones en pagos a creadores.',
        },
      ],
      summaryTag: 'En resumen',
      summaryText:
        'Comenzó como una audaz empresa respaldada por la familia en 2016, creció de manera constante con inversiones clave para 2018, y luego se disparó hasta convertirse en una potencia global para 2020 — revolucionando la monetización de creadores y redefiniendo los modelos de suscripción de contenido digital en todo el mundo.',
      footerTag: 'danceforfans.com · El Archivo',
    },
    investorsPage: {
      headerTag: 'El Piso de Inversores',
      heroTag: '✦ Una oportunidad única ✦',
      heroTitleStart: 'Posee parte de ',
      heroTitleHighlight: 'Dance for Fans',
      heroTitleEnd: '.',
      p1: '¡Bienvenidos inversores! Dance for Fans ofrece una oportunidad única para poseer parte de nuestra plataforma. Vendemos el 49% de la empresa.',
      twoPathsTitle: 'Dos caminos hacia la propiedad.',
      p2: 'Estamos considerando dos caminos. Opción uno: unos pocos inversores grandes, cada uno con una participación importante. Opción dos: 1.000 mujeres — bailarinas o seguidoras — cada una invirtiendo $2.500.',
      option1Tag: 'Camino 1',
      option1Title: 'Unos pocos inversores grandes.',
      option1Desc:
        'Un pequeño grupo de socios estratégicos, cada uno poseyendo una parte sustancial de la empresa. Más rápido de cerrar, menos voces en la mesa.',
      option2Tag: 'Camino 2 · Destacado',
      option2Title: '1.000 mujeres × $2.500.',
      option2Desc:
        'Un modelo impulsado por la comunidad: 1.000 bailarinas o seguidoras, cada una invirtiendo $2.500. Embajadoras integradas, beneficios compartidos, propiedad amplia.',
      mathTag: 'Las matemáticas',
      mathTitle: 'Cómo cuadran los números.',
      stat1: 'Inversoras a $2.500 cada una',
      stat2: 'Tamaño por inversora',
      stat3: 'Total recaudado',
      stat4: 'Capital ofrecido',
      p3: 'En el segundo modelo, si 1.000 mujeres invierten $2.500 cada una, eso suma $2,5 millones en total. Esos $2,5 millones representan toda la participación del 49%.',
      p4Start: 'Cada inversora poseería aproximadamente el ',
      p4Highlight: '0,049%',
      p4End: ' de toda la empresa.',
      upsideTag: 'El potencial',
      upsideTitle: 'Hasta dónde pueden llegar los números.',
      projMonthlyRevLabel: 'Ingresos mensuales de la empresa',
      projInvestorShareLabel: 'Participación inversora del 49%',
      projPerInvestorLabel: 'Por inversora',
      projPerInvestorSub: 'mensual · participación del 0,049%',
      p5: 'Si la empresa crece a $20 millones al mes en ingresos, ese 49% equivaldría a $9,8 millones mensuales. La participación de cada inversora podría rendir alrededor de $9.800 al mes.',
      bigUpsideTag: 'Y si escala aún más',
      bigUpsideP:
        'Ya hemos visto lo rápido que OnlyFans creció hasta $166 millones al mes en menos de cuatro años. Ahora, mira las matemáticas: cuando Dance for Fans llegue a ese nivel, el 49% para las inversoras significa alrededor de $81,3 millones al mes. Con 1.000 inversoras, eso es aproximadamente $81.300 al mes para cada una. Ese es el poder de este modelo.',
      whyOption2Tag: 'Por qué la opción dos',
      whyOption2Title: 'Por qué la opción dos es la elección más fuerte',
      whyOption2Subtitle:
        'Bailarinas como inversoras. Inversoras como bailarinas.',
      whyOption2Intro1:
        'La opción dos destaca porque convierte a las personas que impulsan la plataforma en verdaderas socias de su éxito. En lugar de simplemente usar la plataforma, las bailarinas se involucran en construirla, hacerla crecer y promoverla. Eso crea un nivel de lealtad, pertenencia y compromiso a largo plazo mucho más profundo que cualquier modelo tradicional.',
      whyOption2Intro2:
        'Cuando las creadoras tienen una participación en el negocio, su mentalidad cambia. Ya no son solo participantes — se convierten en embajadoras, defensoras e impulsoras del crecimiento. Ese tipo de alineación es increíblemente poderoso.',
      whyOption2GrowthHeader:
        'Un motor incorporado para un crecimiento más rápido',
      whyOption2GrowthP1:
        'Alcanzar grandes hitos de ingresos, incluido el camino hacia los $20 millones mensuales, se vuelve mucho más alcanzable cuando la base de inversoras y la base de creadoras son la misma. ¿Por qué? Porque las personas que ganan en la plataforma ahora tienen un incentivo directo para ayudar a expandirla.',
      whyOption2GrowthLead: 'Están motivadas para:',
      whyOption2GrowthBullets: [
        'Crear más',
        'Promover más',
        'Traer a otras',
        'Ayudar activamente a construir la comunidad',
      ],
      whyOption2GrowthP2:
        'Eso crea un efecto de red que puede acelerar drásticamente el crecimiento. En lugar de depender solo del marketing externo o de usuarias pasivas, la opción dos construye una comunidad de socias que están financiera y emocionalmente invertidas en el éxito de la plataforma.',
      whyOption2ProvenHeader: 'El modelo está probado',
      whyOption2ProvenP:
        'Ya hemos visto lo rápido que pueden escalar las plataformas impulsadas por creadoras cuando se da el impulso adecuado. Una plataforma de suscripción de fans como OnlyFans alcanzó ingresos mensuales masivos en pocos años porque las creadoras impulsaron tanto la adopción como la retención. Ese mismo tipo de impulso puede ser aún más poderoso aquí cuando las creadoras no solo ganan en la plataforma, sino que también participan en su valorización.',
      whyOption2MattersHeader: 'Por qué esto importa',
      whyOption2MattersP1:
        'La opción dos no es solo una estrategia de financiación — es una estrategia de crecimiento. Crea mayor lealtad, expansión más rápida y una comunidad motivada para ganar juntas.',
      whyOption2MattersP2:
        'Eso es lo que hace que la opción dos sea la mejor elección: alinea la propiedad con la contribución y convierte el crecimiento en una misión compartida.',
      disclaimer:
        'Estas cifras son proyecciones ilustrativas destinadas a mostrar el potencial financiero del modelo. Los resultados reales dependerían del rendimiento de la plataforma, las condiciones del mercado y muchos otros factores. Esto no es una oferta de venta de valores.',
      contactBtn: 'Escribir a jose@danceforfans.com',
      footerTag: 'danceforfans.com · El Piso de Inversores',
    },
  },
  fr: {
    common: {
      backToMain: 'Retour à danceforfans.com',
      backToMainStage: 'Retour à la scène principale',
      conceptInProgress: 'Concept en cours',
      contact: 'Contact',
    },
    hero: {
      badge: 'Concept en cours',
      subBadge: '"If we build it, they will Cum"',
      future: 'futur 2026',
      tagline: 'Une plateforme en mouvement.',
      contactBtn: 'Contactez-nous',
      callBtn: 'jose@danceforfans.com',
    },
    welcome: {
      titleStart: 'Bienvenue sur ',
      titleHighlight: 'Dance for Fans',
      titleEnd:
        ' — la nouvelle plateforme audacieuse qui donne du fil à retordre à OnlyFans.',
      subtitle:
        'Votre prochaine destination pour du contenu exclusif, conçu de manière unique pour les vrais fans.',
    },
    market: {
      opportunity: "L'opportunité",
      p1Start: 'OnlyFans a été lancée en 2016 et a franchi le cap du ',
      p1Highlight: 'milliard de dollars de revenus',
      p1End:
        " d'ici 2020 — une ascension fulgurante de quatre ans basée sur l'économie des créateurs et la demande directe aux consommateurs.",
      cards: [
        {
          title: '2016',
          desc: "Lancée comme une plateforme d'abonnement pour les créateurs.",
        },
        {
          title: '$1B+',
          desc: "Gamme de revenus franchie d'ici 2020 — en seulement quatre ans.",
        },
        {
          title: 'D2C',
          desc: "L'économie des créateurs directe aux consommateurs continue de s'étendre.",
        },
      ],
      p2Start:
        'Le marché a fait ses preuves, la demande est mondiale et les règles sont claires. ',
      p2Highlight: 'Dance for Fans',
      p2End:
        ' est positionnée pour surfer sur cette même vague — avec une identité plus pointue, axée sur la danse.',
    },
    ctas: {
      competitors: {
        tag: 'Découvrez qui est dans la course',
        title: 'Curieux de connaître les concurrents et leurs revenus ?',
        btn: 'Cliquez ici pour voir les concurrents et leurs revenus',
      },
      story: {
        tag: "L'histoire d'origine",
        title: 'Comment OnlyFans a démarré.',
        btn: "Cliquez ici pour l'histoire complète",
      },
      launch: {
        tag: 'Pour les bâtisseurs et opérateurs',
        title:
          'Vous voulez savoir comment lancer une plateforme comme celle-ci ?',
        desc: "Hébergement, infrastructure, échelle, sécurité — nous avons préparé une analyse approfondie de ce qu'il faut pour gérer une plateforme comme danceforfans.com.",
        btn: 'Cliquez ici pour le guide de lancement',
      },
      idea: {
        tag: 'Pour les investisseurs potentiels',
        title: "Vous voulez entendre notre idée d'investissement ?",
        btn: "Cliquez ici pour le détail de l'investissement",
      },
      expectations: {
        tag: 'Pour les danseuses',
        title:
          "Qu'attend-on des danseuses, et qu'est-ce que les danseuses devraient attendre de Dance for Fans ?",
        btn: 'Cliquez ici pour les attentes',
      },
      agreement: {
        tag: 'L\u2019Accord de Partenariat',
        title: 'Découvrez à quoi ressemble un partenariat avec Dance for Fans.',
        subtitle: 'Vous y trouverez aussi des questions et réponses.',
        btn: 'Cliquez Ici Pour Voir À Quoi Ressemble Un Accord Avec Dance For Fans',
      },
    },
    agreementPage: {
      headerTag: 'L\u2019Accord de Partenariat',
      heroTag: '✦ Accord de Partenariat Investisseuse & Danseuse ✦',
      heroTitle: 'À quoi ressemble un accord avec Dance for Fans.',
      heroSubtitle:
        'Un aperçu en langage clair de la façon dont les danseuses deviennent de véritables partenaires de la plateforme.',
      sections: [
        {
          title: 'Introduction',
          paragraphs: [
            'Pour seulement 2 500 $, vous posséderez 0,049 % du total des parts avec Dance for Fans. Cela fait de vous à la fois une créatrice et une partenaire du succès de la plateforme.',
          ],
        },
        {
          title: 'Rôle de l\u2019Investisseuse et Propriété',
          paragraphs: [
            'Nous recherchons :\n\n\u2022 1 000 danseuses à 2 500 $ chacune, possédant 0,049 % chacune, ou\n\u2022 2 000 danseuses à 1 250 $ chacune, possédant 0,0245 % chacune.\n\nAu total, cela constitue le pool d\u2019investissement de 49 %.',
          ],
        },
        {
          title: 'Distribution des Revenus',
          paragraphs: [
            'Dès que Dance for Fans commence à fonctionner, votre distribution démarre immédiatement. Quelle que soit votre part \u2014 par exemple, 0,049 % \u2014 vous commencez à recevoir votre revenu dès le premier instant. Que le site génère 1 million de dollars par mois ou 20 millions de dollars par mois, votre part commence à être versée immédiatement.',
          ],
        },
        {
          title: 'Attentes envers les Investisseuses',
          paragraphs: [
            'Pour maintenir votre part en règle, chaque investisseuse doit consacrer au moins 33 heures par mois à la plateforme \u2014 que ce soit en créant du contenu, en interagissant avec les fans ou en faisant la promotion. En récompense d\u2019être une investisseuse précoce, au lieu de la commission habituelle de 20 %, votre commission n\u2019est que de 15 %.',
          ],
        },
        {
          title: 'Durée et Stratégie de Sortie',
          paragraphs: [
            'La durée est aussi longue que vous restez active. Tant que vous contribuez 33 heures par mois, vous conservez la pleine propriété de votre part.',
            'Si vous souhaitez sortir, vous pouvez vendre votre part, mais uniquement à la prochaine danseuse en liste d\u2019attente. La vente doit se faire au coût, jusqu\u2019à un an de vos revenus à ce moment-là.',
            'Par exemple, si votre part génère 50 000 $ par mois, vous pourriez vendre votre part jusqu\u2019à 600 000 $. Cela garde tout équitable et aligné avec la croissance de la plateforme.',
          ],
        },
        {
          title: 'Protections Légales',
          paragraphs: [
            'Aucun agenda caché \u2014 tout est noir sur blanc. Les investisseuses sont les seules propriétaires de leur part. Comme posséder un bien, cette part leur appartient entièrement. Contrairement à l\u2019immobilier, elles n\u2019ont pas à payer d\u2019impôts, de marketing, de gestion ou de frais opérationnels. Dieu nous en préserve, en cas d\u2019accident ou d\u2019incapacité à performer, elles conservent leur part jusqu\u2019à la guérison.',
          ],
        },
        {
          title: 'Signatures et Accord',
          paragraphs: [
            'Lors de la signature, tout va sur un compte d\u2019entreprise et le développement du site commence. Le délai de démarrage prévu est d\u2019environ 6 à 12 mois.',
          ],
        },
      ],
      qaTitle: 'Questions déjà posées par les danseuses',
      qaSubtitle: 'Voici des questions soumises par curiosité via la page.',
      qa: [
        {
          q: 'Quand suis-je payée, et à quelle fréquence ?',
          a: 'Les paiements commencent dès le premier jour. Aucun délai pour débloquer vos gains \u2014 vous gardez votre part au fur et à mesure. La répartition est détaillée dans la Section 3.',
        },
        {
          q: 'Dois-je montrer mon visage ?',
          a: "Non. Beaucoup d'artistes utilisent des masques, l'\u00e9clairage ou le cadrage pour garder leur identité privée. Vos limites vous appartiennent, et la plateforme les soutient.",
        },
        {
          q: 'Que se passe-t-il si un fan dépasse les limites ?',
          a: "La sécurité est la première règle. Vous pouvez bloquer, mettre en sourdine ou signaler n'importe quel fan à tout moment. Nous prenons le harcèlement au sérieux et agissons rapidement.",
        },
        {
          q: 'Suis-je liée par un long contrat ?',
          a: 'Aucun engagement à long terme. La Section 5 couvre la durée et la sortie \u2014 vous pouvez partir avec un préavis raisonnable. Nous gagnons votre loyauté, nous ne l\u2019imposons pas.',
        },
        {
          q: 'Qui possède mon contenu ?',
          a: 'Vous. Dance for Fans n\u2019a qu\u2019une licence pour héberger et distribuer votre contenu sur la plateforme \u2014 la propriété complète reste la vôtre.',
        },
        {
          q: "L'IA sera-t-elle autorisée sur Dance for Fans ?",
          a: "Non, les bots d'IA ne seront pas autorisés. Si nous surprenons quelqu'un utilisant l'IA ou des bots, nous bloquerons cette adresse IP et l'empêcherons d'utiliser à nouveau le site.",
        },
        {
          q: 'Si nous investissons, pourquoi devons-nous quand même nous connecter pendant les 33 heures par mois ?',
          a: "Le service corporatif et le service client travailleront sans relâche en coulisses. En tant qu'investisseur, contribuer 33 heures par mois aide à maintenir un engagement élevé et à construire la communauté. Au final, votre part vous appartient, et tous les retours vous reviennent directement. Nous ne demandons pas de paiements supplémentaires pour les opérations corporatives, les frais généraux ou les factures \u2014 seulement votre temps et votre passion pour aider la plateforme à prospérer.",
        },
        {
          q: "En tant qu'investisseur, avons-nous accès aux finances, et comment obtiendrons-nous ces informations ?",
          a: "Vous n'aurez pas accès à toutes les finances, car cela est géré par le service corporatif, mais vous recevrez un rapport hebdomadaire indiquant exactement combien d'argent est entré \u2014 que ce soit un lundi ou un vendredi \u2014 afin que vous sachiez toujours comment la plateforme se porte.",
        },
        {
          q: 'Quelle est la différence entre Dance for Fans et OnlyFans ?',
          a: "Dance for Fans est construite sur le partenariat. Les danseuses ne créent pas seulement du contenu, elles deviennent aussi investisseuses avec une véritable part dans la plateforme. Nous offrons un salon principal où les danseuses peuvent présenter des performances en direct et attirer de nouveaux abonnés. De plus, nous mettons l'accent sur une communauté sûre et solidaire, et des commissions globales plus basses pour les premières investisseuses.",
        },
      ],
      closing:
        'Un accord réel, rédigé par des avocats, suivra le même esprit \u2014 juste, transparent et construit autour du partenariat.',
      draftNotice: 'Brouillon d\u2019aperçu \u00b7 Pas un contrat contraignant',
      footerTag: 'danceforfans.com \u00b7 L\u2019Accord de Partenariat',
    },
    expectationsPage: {
      headerTag: 'Le Contrat de Scène',
      heroTag: '✦ Les attentes ✦',
      heroTitle: 'Ce que nous attendons des danseuses.',
      heroSubtitle:
        'Dance for Fans repose sur le partenariat. Voici ce que nous demandons à chaque danseuse qui monte sur scène avec nous.',
      items: [
        {
          title: "La sécurité d'abord.",
          desc: 'La sécurité des femmes est la priorité absolue sur Dance for Fans. Restez en ligne, évitez de rencontrer qui que ce soit en personne et privilégiez toujours votre bien-être.',
        },
        {
          title: 'Créer du contenu régulier et engageant.',
          desc: 'Chorégraphies, coulisses, tutoriels ou sessions interactives — gardez la scène vivante et votre public fidèle.',
        },
        {
          title: 'Promouvoir votre profil et la plateforme.',
          desc: 'Aidez à construire une communauté forte en partageant votre profil et Dance for Fans sur vos canaux et réseaux.',
        },
        {
          title: 'Interagir directement avec les fans.',
          desc: 'Cultivez la fidélité et stimulez les abonnements en discutant avec les fans, en répondant aux messages et en les faisant se sentir vus.',
        },
        {
          title: "Collaborer avec d'autres danseuses.",
          desc: "Faites équipe avec d'autres danseuses pour créer du contenu spécial, des streams communs ou des événements qui font grandir toute la communauté.",
        },
        {
          title: 'Être une vraie partenaire.',
          desc: "Ne vous contentez pas de gagner de l'argent avec votre contenu — partagez le succès de la plateforme. Nous construisons cela ensemble.",
        },
      ],
      platformTag: 'En retour',
      platformTitle:
        'Ce que les danseuses devraient attendre de Dance for Fans',
      platformItems: [
        {
          title: 'Des paiements transparents et équitables.',
          desc: 'Des paiements clairs et à temps dès le premier jour. Pas de frais cachés, pas de surprises \u2014 ce que vous gagnez, vous le recevez.',
        },
        {
          title: 'Des primes mensuelles pour les meilleures.',
          desc: 'Nous valorisons toutes les danseuses \u2014 il y aura des primes mensuelles pour celles qui gagnent le plus et celles qui sont les plus engagées dans les interactions en ligne avec les clients.',
        },
        {
          title: 'Une récompense de vacances payées chaque année.',
          desc: 'Chaque année, les danseuses les plus actives \u2014 surtout celles qui interagissent constamment \u2014 recevront une récompense de vacances payées.',
        },
        {
          title: 'Une vraie voix dans la plateforme.',
          desc: "Nous valorisons toutes les contributions \u2014 c'est pourquoi nous avons plus de mille danseuses-performeuses comme investisseuses, pour écouter et rester connectées à ce qui compte vraiment.",
        },
        {
          title: 'Une vraie scène dans le showroom principal.',
          desc: "Contrairement à d'autres sites, nous aurons un showroom principal où les danseuses bénéficient de 15 à 20 minutes de temps réel sur scène en direct. Cela donne aux clients la chance de vous voir en action, et peut les attirer vers votre page et vos sessions privées, générant plus d'engagement et d'abonnés.",
        },
      ],
      closing:
        "Ce ne sont pas des règles — c'est le rythme de la plateforme. Quand les danseuses arrivent, toute la scène s'illumine.",
      footerTag: 'danceforfans.com · Le Contrat de Scène',
    },
    vision: {
      p1: 'Dance for Fans est une plateforme émergente pour adultes 18+, axée sur la danse sensuelle et expressive. Elle est parfaite pour les couples—pensez aux couples de dirty dancing—et pour les hommes et femmes célibataires qui veulent partager leur art. Nous accueillons également avec fierté la communauté LGBTQ+.',
      p2: "Dance for Fans aura un salon principal où chaque danseur ou danseuse s'inscrit sur une liste d'attente pour avoir sa chance d'être sur la scène principale. Les couples, les solos et tous les artistes ont l'occasion de se produire en direct, ce qui les aide à trouver les clients et les fans qui résonnent avec eux et les suivent sur leurs pages privées.",
      p3Start:
        "C'est du divertissement pour adultes qui célèbre la créativité audacieuse, l'intimité et la connexion, donnant aux artistes la chance de briller et d'attirer des fans qui apprécient leur travail.",
      p3Highlight: '',
    },
    sections: {
      title: 'Deux scènes. Une communauté.',
      subtitle:
        "Nous nous engageons à autonomiser les créateurs de tous horizons. C'est pourquoi nous envisageons deux sections distinctes, garantissant que chaque artiste atteigne le bon public.",
      openFloor: {
        title: 'Piste Ouverte',
        desc: "Pour les créateurs de danse en général et tous les styles. Un espace dédié à l'art du mouvement, du contemporain au hip-hop, du ballet au breakdance.",
        bullets: [
          'Tous âges bienvenus',
          'Outils de monétisation flexibles',
          'Communauté de soutien',
        ],
      },
      afterHours: {
        tag: '18+ SEULEMENT',
        title: 'Après les Heures',
        desc: 'Pour ceux qui explorent le contenu pour adultes. Un environnement de bon goût et sécurisé garantissant que les artistes atteignent le bon public pour des expressions plus matures.',
        bullets: [
          "Environnement avec restriction d'âge",
          'Monétisation premium',
          'Discret et sécurisé',
        ],
      },
    },
    join: {
      tag: 'Rejoignez dès le départ',
      title: 'Envie de rejoindre Dance for Fans ?',
      subtitle:
        'Si vous souhaitez nous rejoindre dès le départ, laissez-nous vos infos ci-dessous et nous vous recontacterons.',
      q1: 'Quel est votre identifiant Instagram ?',
      q2: 'Quel est votre âge ? (18+)',
      q3: 'Quelle est votre expérience en création de contenu ?',
      q3Placeholder: 'Parlez-nous de votre parcours, plateformes, style…',
      q4: 'Combien d’abonnés avez-vous actuellement sur toutes les plateformes ?',
      q4Placeholder: 'ex. 12k sur IG, 3k sur TikTok',
      q5: 'La meilleure façon de vous joindre et toutes vos questions, ici.',
      q5Placeholder: "Qu'est-ce qui ferait de cette plateforme un succès ?",
      btn: 'Cliquez ici',
    },
    domain: {
      title: "Façonnez l'avenir.",
      descStart: 'Ce concept est encore en cours de réflexion. Son foyer est ',
      descHighlight: 'danceforfans.com',
      descEnd: '.',
      directContact: 'Contact Direct',
      askForStart: 'Écrivez-nous à ',
      askForHighlight: 'jose@danceforfans.com',
      askForEnd:
        " pour discuter de l'acquisition de ce domaine et de ce concept.",
    },
    visit: {
      counting: 'Comptage des visites…',
      visits: 'visites',
    },
    launchPage: {
      headerTag: 'Les Coulisses',
      heroTag: '✦ Rideau de velours · Laissez-passer ✦',
      heroTitleStart: 'Comment lancer une plateforme comme ',
      heroTitleHighlight: 'Dance for Fans',
      heroTitleEnd: '.',
      heroDesc:
        "Bienvenue dans les coulisses. Avant que les projecteurs ne s'allument, chaque grand spectacle a besoin d'une structure — énergie, éclairage, sécurité, une scène qui ne cédera pas quand la foule arrivera. Voici ce qu'il faut.",
      intro1:
        "Pour l'hébergement, vous aurez besoin d'un fournisseur capable de gérer de gros téléchargements de fichiers, des paiements sécurisés et un trafic élevé.",
      intro2:
        'Plongeons dans les détails — voici les meilleurs choix pour une opération comme celle-ci.',
      providers: [
        {
          name: 'Amazon Web Services (AWS)',
          tag: 'Le plus flexible · Recommandé',
          desc: "Hautement évolutif avec des services comme EC2 pour héberger votre application, S3 pour stocker des fichiers multimédias et CloudFront comme CDN. AWS offre également d'excellentes fonctionnalités de sécurité et des outils de conformité dès le départ.",
          bullets: [
            "Calcul EC2 et mise à l'échelle automatique",
            'S3 pour le stockage multimédia',
            'CDN CloudFront',
            'Outils IAM, KMS et conformité',
          ],
        },
        {
          name: 'Google Cloud Platform (GCP)',
          tag: 'Le plus flexible · Recommandé',
          desc: "Similaire à AWS en termes d'échelle et de capacité — stockage sécurisé, calcul puissant, analyses de classe mondiale et intégration transparente avec le reste de l'écosystème Google.",
          bullets: [
            'Cloud Storage et Compute Engine',
            'Analyses puissantes (BigQuery)',
            'CDN mondial',
            'Prêt pour le ML/IA',
          ],
        },
        {
          name: 'Microsoft Azure',
          tag: 'Niveau entreprise',
          desc: 'Puissant, avec une sécurité de niveau entreprise, des fonctionnalités de conformité approfondies et des centres de données mondiaux pour des performances à faible latence dans le monde entier.',
          bullets: [
            "Conformité d'entreprise",
            'Centres de données mondiaux',
            'Prise en charge du cloud hybride',
            "Outils d'identité solides",
          ],
        },
        {
          name: 'DigitalOcean',
          tag: 'Simple pour commencer',
          desc: "Plus simple et plus direct — idéal pour les projets à plus petite échelle qui ont besoin d'espace pour évoluer plus tard. Bases de données gérées, stockage et serveurs faciles à déployer.",
          bullets: [
            'Bases de données gérées',
            "Stockage d'objets Spaces",
            'Prix prévisibles',
            'UX conviviale pour les développeurs',
          ],
        },
        {
          name: 'Vultr / Linode',
          tag: 'VPS rentable',
          desc: "Serveurs privés virtuels haute performance. Rentables et idéaux si vous voulez plus de contrôle et que cela ne vous dérange pas de gérer l'infrastructure vous-même.",
          bullets: [
            'VPS rapide et bon marché',
            'Régions mondiales',
            'Contrôle root total',
            'Bon pour les petites équipes',
          ],
        },
      ],
      bottomTag: 'En conclusion',
      bottomTitleStart:
        'Pour un projet comme Dance for Fans — avec beaucoup de médias et un trafic élevé — ',
      bottomTitleHighlight: 'AWS ou GCP',
      bottomTitleEnd: ' sont les choix les plus flexibles et évolutifs.',
      bottomDesc:
        "Ils vous donnent de l'espace pour grandir, avec tous les outils dont vous avez besoin : stockage, sécurité, performances et même apprentissage automatique lorsque vous êtes prêt à ajouter des fonctionnalités avancées.",
      footerTag: 'danceforfans.com · Les Coulisses',
    },
    competitorsPage: {
      headerTag: "Le Plancher de l'Argent",
      heroTag: "✦ Suivez l'argent ✦",
      heroTitleStart: 'Les concurrents et leurs ',
      heroTitleHighlight: 'revenus',
      heroTitleEnd: '.',
      heroDesc:
        "Le marché est réel et les chiffres racontent l'histoire. Voici le leader qui a construit cette catégorie — et les sept plus grands noms qui les poursuivent.",
      incumbentTag: 'Le leader',
      incumbentSubTag: 'Leader du marché',
      incumbentName: 'Le Leader "Seulement pour les Fans"',
      incumbentDesc:
        "OnlyFans a été lancée en 2016 comme une plateforme d'abonnement pour que les créateurs partagent du contenu directement avec leurs fans. Elle a connu une croissance rapide, dépassant le milliard de dollars de revenus d'ici 2020, en exploitant l'économie croissante des créateurs et la demande de contenu exclusif. Cette ascension fulgurante a pris environ quatre ans, stimulée par son modèle commercial unique et le passage aux services numériques directs aux consommateurs.",
      incumbentRevLabel: 'Revenus Annuels',
      incumbentRevVal: '$1B+',
      incumbentRevSub: "d'ici 2020 · en seulement 4 ans",
      top7Tag: 'Les 7 Principaux Concurrents',
      estRevLabel: 'Revenus Est.',
      competitors: [
        {
          name: 'Patreon',
          rev: '~$160M / an',
          desc: "L'un des plus grands concurrents, axé sur les abonnements de créateurs pour toutes sortes de contenus.",
        },
        {
          name: 'Fansly',
          rev: '~$50M – $100M / an',
          desc: 'Croissance rapide, et estimé à rapporter entre cinquante et cent millions par an.',
        },
        {
          name: 'FanCentro',
          rev: '~$20M – $40M / an',
          desc: "Une plateforme bien établie dans l'économie des créateurs, estimée à environ vingt à quarante millions par an.",
        },
        {
          name: 'AVN Stars',
          rev: '~$10M – $20M / an',
          desc: 'Connectée à la marque AVN, rapporte probablement environ dix à vingt millions par an.',
        },
        {
          name: 'JustFor.Fans',
          rev: '~$5M – $15M / an',
          desc: 'Une plateforme de niche, estimée à environ cinq à quinze millions par an.',
        },
        {
          name: 'Unlockd',
          rev: '~$3M – $10M / an',
          desc: "Un acteur plus récent dans l'espace, estimé à environ trois à dix millions par an.",
        },
        {
          name: 'IsMyGirl',
          rev: '~$2M – $5M / an',
          desc: 'Plus petite, mais toujours notable dans la niche — estimée à environ deux à cinq millions par an.',
        },
      ],
      bottomTag: 'En conclusion',
      bottomTitleStart: 'Une catégorie valant des ',
      bottomTitleHighlight: 'milliards',
      bottomTitleEnd:
        ' — et les finalistes gagnent à eux seuls des centaines de millions par an.',
      bottomDescStart: '',
      bottomDescHighlight: 'Dance for Fans',
      bottomDescEnd:
        ' entre sur ce marché avec une identité plus pointue, un public dévoué et une marge de croissance évidente.',
      footerTag: "danceforfans.com · Le Plancher de l'Argent",
    },
    storyPage: {
      headerTag: "L'Archive",
      heroTag: 'Chapitre zéro',
      heroTitleStart: 'De zéro à des ',
      heroTitleHighlight: 'milliards',
      heroTitleEnd: '.',
      heroDescStart: 'En seulement ',
      heroDescHighlight: '10 ans',
      heroDescEnd:
        ", OnlyFans est passée d'un prêt de 10 000 £ à un phénomène mondial de l'économie des créateurs. Voici comment.",
      chapters: [
        {
          year: '2016',
          title: 'Un pari soutenu par la famille.',
          body: "Le fondateur de la plateforme, Tim Stokely, a lancé le site avec le soutien initial de sa famille. Il aurait emprunté environ 10 000 £ à son père, Guy Stokely, pour lancer le site. Ce financement initial a couvert les coûts de développement et de marketing précoce, permettant à la plateforme d'attirer lentement sa première vague de créateurs de contenu — un début discret pour ce qui allait devenir une entreprise définissant une catégorie.",
        },
        {
          year: '2017 – 2018',
          title: 'Élan et participation majoritaire.',
          body: "D'ici 2017 et 2018, la plateforme avait commencé à gagner un véritable élan. Elle a attiré des influenceurs de diverses industries, et son modèle d'abonnement a résonné auprès des créateurs à la recherche d'une monétisation directe. En 2018, Leonid Radvinsky — connu pour son expérience dans les plateformes de divertissement pour adultes — a acheté une participation de 75 % dans l'entreprise. Son implication a apporté des investissements importants et un sens des affaires, aidant à professionnaliser les opérations et à étendre la portée.",
        },
        {
          year: '2019 – 2021',
          title: "L'explosion.",
          body: "À partir de 2019, la plateforme a explosé en popularité. La base de créateurs s'est diversifiée — influenceurs, musiciens, coachs de fitness et artistes pour adultes y ont tous afflué. La pandémie de COVID-19 a encore accéléré sa croissance, de nombreux créateurs se tournant vers les plateformes en ligne pour obtenir des revenus. D'ici 2020 et 2021, elle était devenue un phénomène mondial, avec des millions d'utilisateurs et des milliards de paiements aux créateurs.",
        },
      ],
      summaryTag: 'En bref',
      summaryText:
        "Cela a commencé comme une entreprise audacieuse soutenue par la famille en 2016, a connu une croissance constante avec des investissements clés d'ici 2018, puis a explosé pour devenir une puissance mondiale d'ici 2020 — révolutionnant la monétisation des créateurs et redéfinissant les modèles d'abonnement au contenu numérique dans le monde entier.",
      footerTag: "danceforfans.com · L'Archive",
    },
    investorsPage: {
      headerTag: 'Le Plancher des Investisseurs',
      heroTag: '✦ Une opportunité unique ✦',
      heroTitleStart: 'Possédez une part de ',
      heroTitleHighlight: 'Dance for Fans',
      heroTitleEnd: '.',
      p1: 'Bienvenue investisseurs ! Dance for Fans offre une opportunité unique de posséder une partie de notre plateforme. Nous vendons 49 % de la société.',
      twoPathsTitle: 'Deux chemins vers la propriété.',
      p2: 'Nous envisageons deux chemins. Option un : quelques grands investisseurs, chacun possédant une grande part. Option deux : 1 000 femmes — danseuses ou supportrices — investissant chacune 2 500 $.',
      option1Tag: 'Chemin 1',
      option1Title: 'Quelques grands investisseurs.',
      option1Desc:
        "Un petit groupe de partenaires stratégiques, chacun possédant une part substantielle de l'entreprise. Plus rapide à conclure, moins de voix à la table.",
      option2Tag: 'Chemin 2 · En vedette',
      option2Title: '1 000 femmes × 2 500 $.',
      option2Desc:
        'Un modèle communautaire — 1 000 danseuses ou supportrices investissant chacune 2 500 $. Des ambassadrices intégrées, des gains partagés, une propriété large.',
      mathTag: 'Le calcul',
      mathTitle: "Comment les chiffres s'additionnent.",
      stat1: 'Investisseuses à 2 500 $ chacune',
      stat2: 'Ticket par investisseuse',
      stat3: 'Total levé',
      stat4: 'Capital offert',
      p3: 'Dans le deuxième modèle, si 1 000 femmes investissent 2 500 $ chacune, cela rapporte 2,5 millions de dollars au total. Ces 2,5 millions de dollars représentent la totalité de la participation de 49 %.',
      p4Start: 'Chaque investisseuse posséderait environ ',
      p4Highlight: '0,049 %',
      p4End: " de l'ensemble de l'entreprise.",
      upsideTag: 'Le potentiel',
      upsideTitle: 'Jusquoù les chiffres peuvent aller.',
      projMonthlyRevLabel: "Revenus mensuels de l'entreprise",
      projInvestorShareLabel: 'Part investisseuse de 49 %',
      projPerInvestorLabel: 'Par investisseuse',
      projPerInvestorSub: 'mensuel · part de 0,049 %',
      p5: "Si l'entreprise atteint 20 millions de dollars de revenus mensuels, ces 49 % équivaudraient à 9,8 millions de dollars par mois. La part de chaque investisseuse pourrait potentiellement rapporter environ 9 800 $ par mois.",
      bigUpsideTag: 'Et si ça monte encore plus haut',
      bigUpsideP:
        'Nous avons déjà vu à quelle vitesse OnlyFans a atteint 166 millions de dollars par mois en moins de quatre ans. Maintenant, regardez les chiffres : lorsque Dance for Fans atteindra ce niveau, 49 % pour les investisseuses représente environ 81,3 millions de dollars par mois. Avec 1 000 investisseuses, cela fait environ 81 300 $ par mois chacune. Voilà la puissance de ce modèle.',
      whyOption2Tag: "Pourquoi l'option deux",
      whyOption2Title: "Pourquoi l'option deux est le choix le plus fort",
      whyOption2Subtitle:
        'Les danseuses comme investisseuses. Les investisseuses comme danseuses.',
      whyOption2Intro1:
        "L'option deux se distingue parce qu'elle transforme les personnes qui font vivre la plateforme en véritables partenaires de son succès. Au lieu de simplement utiliser la plateforme, les danseuses s'investissent dans sa construction, sa croissance et sa promotion. Cela crée un niveau de loyauté, d'appropriation et d'engagement à long terme bien plus profond qu'un modèle traditionnel ne pourrait jamais l'offrir.",
      whyOption2Intro2:
        "Lorsque les créatrices détiennent une part de l'entreprise, leur mentalité change. Elles ne sont plus de simples participantes — elles deviennent ambassadrices, défenseures et moteurs de croissance. Ce type d'alignement est incroyablement puissant.",
      whyOption2GrowthHeader:
        'Un moteur intégré pour une croissance plus rapide',
      whyOption2GrowthP1:
        "Atteindre des étapes majeures de revenus, y compris le chemin vers 20 millions de dollars par mois, devient bien plus accessible lorsque la base des investisseuses et celle des créatrices ne font qu'une. Pourquoi ? Parce que les personnes qui gagnent sur la plateforme ont désormais une incitation directe à aider à l'étendre.",
      whyOption2GrowthLead: 'Elles sont motivées à :',
      whyOption2GrowthBullets: [
        'Créer davantage',
        'Promouvoir davantage',
        "Faire venir d'autres personnes",
        'Aider activement à construire la communauté',
      ],
      whyOption2GrowthP2:
        "Cela crée un effet de réseau qui peut accélérer considérablement la croissance. Au lieu de dépendre uniquement du marketing externe ou d'utilisatrices passives, l'option deux construit une communauté de partenaires financièrement et émotionnellement investies dans le succès de la plateforme.",
      whyOption2ProvenHeader: 'Le modèle est éprouvé',
      whyOption2ProvenP:
        "Nous avons déjà vu à quelle vitesse les plateformes pilotées par les créatrices peuvent évoluer lorsque le bon élan est en place. Une plateforme d'abonnement de fans comme OnlyFans a atteint des revenus mensuels massifs en quelques courtes années parce que les créatrices ont alimenté à la fois l'adoption et la rétention. Ce même type d'élan peut être encore plus puissant ici lorsque les créatrices gagnent non seulement sur la plateforme, mais participent également à sa valorisation.",
      whyOption2MattersHeader: "Pourquoi c'est important",
      whyOption2MattersP1:
        "L'option deux n'est pas seulement une stratégie de financement — c'est une stratégie de croissance. Elle crée une loyauté plus forte, une expansion plus rapide et une communauté motivée à gagner ensemble.",
      whyOption2MattersP2:
        "C'est ce qui fait de l'option deux le meilleur choix : elle aligne la propriété avec la contribution et transforme la croissance en une mission partagée.",
      disclaimer:
        "Ces chiffres sont des projections illustratives destinées à montrer le potentiel financier du modèle. Les résultats réels dépendraient des performances de la plateforme, des conditions du marché et de nombreux autres facteurs. Ceci n'est pas une offre de vente de titres.",
      contactBtn: 'Écrire à jose@danceforfans.com',
      footerTag: 'danceforfans.com · Le Plancher des Investisseurs',
    },
  },
  ru: {
    common: {
      backToMain: 'Вернуться на danceforfans.com',
      backToMainStage: 'Вернуться на главную сцену',
      conceptInProgress: 'Концепция в разработке',
      contact: 'Контакты',
    },
    hero: {
      badge: 'Концепция в разработке',
      subBadge: '"If we build it, they will Cum"',
      future: 'будущее 2026',
      tagline: 'Платформа в движении.',
      contactBtn: 'Связаться с нами',
      callBtn: 'jose@danceforfans.com',
    },
    welcome: {
      titleStart: 'Добро пожаловать на ',
      titleHighlight: 'Dance for Fans',
      titleEnd:
        ' — смелую новую платформу, которая составит серьезную конкуренцию OnlyFans.',
      subtitle:
        'Ваше новое место для эксклюзивного контента, созданное специально для истинных фанатов.',
    },
    market: {
      opportunity: 'Возможность',
      p1Start: 'OnlyFans была запущена в 2016 году и превысила ',
      p1Highlight: 'миллиард долларов дохода',
      p1End:
        ' к 2020 году — стремительный четырехлетний взлет, основанный на экономике создателей и прямом спросе потребителей.',
      cards: [
        {
          title: '2016',
          desc: 'Запущена как платформа подписки для создателей.',
        },
        {
          title: '$1B+',
          desc: 'Диапазон доходов превышен к 2020 году — всего за четыре года.',
        },
        {
          title: 'D2C',
          desc: 'Экономика создателей напрямую потребителю продолжает расширяться.',
        },
      ],
      p2Start: 'Рынок доказан, спрос глобален, а правила ясны. ',
      p2Highlight: 'Dance for Fans',
      p2End:
        ' позиционируется, чтобы войти в эту же волну — с более четкой, танцевальной идентичностью.',
    },
    ctas: {
      competitors: {
        tag: 'Посмотрите, кто в игре',
        title: 'Интересуетесь конкурентами и их доходами?',
        btn: 'Нажмите здесь, чтобы увидеть конкурентов и их доходы',
      },
      story: {
        tag: 'История создания',
        title: 'Как начинался OnlyFans.',
        btn: 'Нажмите здесь для полной истории',
      },
      launch: {
        tag: 'Для создателей и операторов',
        title: 'Хотите узнать, как запустить такую платформу?',
        desc: 'Хостинг, инфраструктура, масштаб, безопасность — мы подготовили глубокий анализ того, что нужно для управления платформой вроде danceforfans.com.',
        btn: 'Нажмите здесь для руководства по запуску',
      },
      idea: {
        tag: 'Для потенциальных инвесторов',
        title: 'Хотите услышать нашу инвестиционную идею?',
        btn: 'Нажмите здесь для разбора инвестиции',
      },
      expectations: {
        tag: 'Для танцовщиц',
        title:
          'Что ожидается от танцовщиц, и чего танцовщицам стоит ожидать от Dance for Fans?',
        btn: 'Нажмите здесь для ожиданий',
      },
      agreement: {
        tag: 'Соглашение о партнёрстве',
        title: 'Узнайте, как выглядит партнёрство с Dance for Fans.',
        subtitle: 'Здесь вы также найдёте вопросы и ответы.',
        btn: 'Нажмите Здесь, Чтобы Узнать, Как Выглядит Соглашение С Dance For Fans',
      },
    },
    agreementPage: {
      headerTag: 'Соглашение о партнёрстве',
      heroTag: '✦ Соглашение о партнёрстве инвестора и танцовщицы ✦',
      heroTitle: 'Как выглядит соглашение с Dance for Fans.',
      heroSubtitle:
        'Простой и понятный обзор того, как танцовщицы становятся настоящими партнёрами платформы.',
      sections: [
        {
          title: 'Введение',
          paragraphs: [
            'Всего за 2 500 $ вы получите 0,049% от общей доли с Dance for Fans. Это делает вас одновременно и создателем, и партнёром в успехе платформы.',
          ],
        },
        {
          title: 'Роль инвестора и владение',
          paragraphs: [
            'Мы ищем:\n\n\u2022 1 000 танцовщиц по 2 500 $ каждая, владеющих 0,049% каждая, или\n\u2022 2 000 танцовщиц по 1 250 $ каждая, владеющих 0,0245% каждая.\n\nВместе это составляет общий инвесторский пул в 49%.',
          ],
        },
        {
          title: 'Распределение доходов',
          paragraphs: [
            'Как только Dance for Fans начнёт работать, ваше распределение включается сразу же. Какой бы ни была ваша доля \u2014 например, 0,049% \u2014 вы начинаете получать свой доход с самого начала. Будь то $1 миллион в месяц или $20 миллионов в месяц, ваша доля начинает выплачиваться немедленно.',
          ],
        },
        {
          title: 'Ожидания от инвестора',
          paragraphs: [
            'Чтобы сохранить свою долю в хорошем состоянии, каждый инвестор должен уделять платформе минимум 33 часа в месяц \u2014 будь то создание контента, общение с фанатами или продвижение. В качестве награды за раннюю инвестицию, вместо обычной комиссии 20%, ваша комиссия составляет всего 15%.',
          ],
        },
        {
          title: 'Срок действия и стратегия выхода',
          paragraphs: [
            'Срок действует, пока вы остаётесь активны. Пока вы уделяете 33 часа в месяц, вы сохраняете полное право собственности на свою долю.',
            'Если вы захотите выйти, вы можете продать свою долю, но только следующей топовой танцовщице в очереди. Продажа должна быть по себестоимости, до годового эквивалента вашего дохода на тот момент.',
            'Например, если ваша доля приносит $50 000 в месяц, вы могли бы продать её за сумму до $600 000. Это сохраняет всё справедливым и согласованным с ростом платформы.',
          ],
        },
        {
          title: 'Юридические защиты',
          paragraphs: [
            'Никаких скрытых намерений \u2014 всё чёрным по белому. Инвесторы являются единственными владельцами своей доли. Как и при владении недвижимостью, эта доля полностью принадлежит им. В отличие от недвижимости, им не нужно платить налоги, маркетинг, управление или операционные расходы. Не дай Бог, если произойдёт несчастный случай или они не смогут выступать, они сохраняют свою долю до восстановления.',
          ],
        },
        {
          title: 'Подписи и соглашение',
          paragraphs: [
            'После подписания всё переходит на корпоративный счёт, и начинается разработка сайта. Ожидаемое время запуска составляет примерно 6\u201312 месяцев.',
          ],
        },
      ],
      qaTitle: 'Вопросы, которые уже задавали танцовщицы',
      qaSubtitle: 'Это вопросы, отправленные из любопытства через страницу.',
      qa: [
        {
          q: 'Когда я получаю выплаты и как часто?',
          a: 'Выплаты начинаются с первого дня. Нет периода ожидания для разблокировки заработка \u2014 ваша доля поступает по мере её получения. Разделение описано в Разделе 3.',
        },
        {
          q: 'Нужно ли мне показывать лицо?',
          a: 'Нет. Многие исполнительницы используют маски, освещение или ракурсы, чтобы сохранить личность приватной. Ваши границы вы устанавливаете сами, а платформа их поддерживает.',
        },
        {
          q: 'Что если фанат переходит границы?',
          a: 'Безопасность \u2014 первое правило. Вы можете заблокировать, заглушить или пожаловаться на любого фаната в любой момент. Мы серьёзно относимся к преследованию и действуем быстро.',
        },
        {
          q: 'Я привязана к длинному контракту?',
          a: 'Никакой долгосрочной привязки. Раздел 5 описывает срок и выход \u2014 вы можете уйти с разумным уведомлением. Мы заслуживаем вашу лояльность, а не навязываем её.',
        },
        {
          q: 'Кому принадлежит мой контент?',
          a: 'Вам. Dance for Fans только лицензирует ваш контент, чтобы размещать и распространять его на платформе \u2014 полное право собственности остаётся за вами.',
        },
        {
          q: 'Будет ли разрешено использование ИИ в Dance for Fans?',
          a: 'Нет, ИИ-боты не будут разрешены. Если мы поймаем кого-то на использовании ИИ или ботов, мы заблокируем этот IP-адрес и навсегда запретим этому человеку пользоваться сайтом.',
        },
        {
          q: 'Если мы инвестируем, почему мы всё равно должны входить в систему на 33 часа в месяц?',
          a: 'Корпоративная часть и служба поддержки будут работать без остановки за кулисами. Как инвестор, вклад в 33 часа в месяц помогает поддерживать высокий уровень вовлечённости и строить сообщество. В конечном итоге ваша доля принадлежит только вам, и вся прибыль идёт напрямую к вам. Мы не просим дополнительных платежей за корпоративные операции, накладные расходы или счета \u2014 только ваше время и страсть, чтобы помочь платформе процветать.',
        },
        {
          q: 'Как инвесторы, имеем ли мы доступ к финансовой отчётности, и как мы будем получать эту информацию?',
          a: 'У вас не будет доступа ко всей финансовой отчётности, так как этим занимается корпоративная часть, но вы будете получать еженедельный отчёт, показывающий, сколько именно денег поступило \u2014 будь то в понедельник или пятницу \u2014 чтобы вы всегда знали, как работает платформа.',
        },
        {
          q: 'В чём разница между Dance for Fans и OnlyFans?',
          a: 'Dance for Fans построена на партнёрстве. Танцовщицы не только создают контент, но и становятся инвесторами с реальной долей в платформе. Мы предлагаем главный зал, где танцовщицы могут выступать вживую и привлекать новых подписчиков. Кроме того, мы делаем акцент на безопасном, поддерживающем сообществе и более низких общих комиссиях для ранних инвесторов.',
        },
      ],
      closing:
        'Реальное соглашение, составленное юристами, будет следовать тому же духу \u2014 справедливо, прозрачно и построено вокруг партнёрства.',
      draftNotice:
        'Черновик предварительного просмотра \u00b7 Не является обязывающим контрактом',
      footerTag: 'danceforfans.com \u00b7 Соглашение о партнёрстве',
    },
    expectationsPage: {
      headerTag: 'Сценический контракт',
      heroTag: '✦ Ожидания ✦',
      heroTitle: 'Что ожидается от танцовщиц.',
      heroSubtitle:
        'Dance for Fans построен на партнёрстве. Вот что мы просим от каждой танцовщицы, выходящей на сцену с нами.',
      items: [
        {
          title: 'Безопасность прежде всего.',
          desc: 'Безопасность женщин — главный приоритет в Dance for Fans. Оставайтесь онлайн, избегайте встреч с кем-либо лично и всегда ставьте своё благополучие на первое место.',
        },
        {
          title: 'Создавайте регулярный, увлекательный контент.',
          desc: 'Танцевальные номера, закулисные клипы, уроки или интерактивные сессии — поддерживайте сцену живой, а аудиторию — возвращающейся.',
        },
        {
          title: 'Продвигайте свой профиль и платформу.',
          desc: 'Помогайте создавать сильное сообщество, делясь своим профилем и Dance for Fans в ваших каналах и сетях.',
        },
        {
          title: 'Общайтесь с фанатами напрямую.',
          desc: 'Развивайте лояльность и увеличивайте подписки, общаясь с фанатами, отвечая на сообщения и давая им почувствовать себя замеченными.',
        },
        {
          title: 'Сотрудничайте с другими танцовщицами.',
          desc: 'Объединяйтесь с другими танцовщицами для создания специального контента, совместных стримов или событий, которые растят всё сообщество.',
        },
        {
          title: 'Будьте настоящим партнёром.',
          desc: 'Не просто зарабатывайте на своём контенте — разделяйте успех платформы. Мы строим это вместе.',
        },
      ],
      platformTag: 'Взамен',
      platformTitle: 'Что танцовщицам стоит ожидать от Dance for Fans',
      platformItems: [
        {
          title: 'Прозрачные и справедливые выплаты.',
          desc: 'Чёткие, своевременные выплаты с первого дня. Никаких скрытых комиссий, никаких сюрпризов — что вы зарабатываете, то и получаете.',
        },
        {
          title: 'Ежемесячные бонусы для лучших.',
          desc: 'Мы ценим всех танцовщиц — будут ежемесячные бонусы для тех, кто больше всех зарабатывает и активнее всех общается с клиентами онлайн.',
        },
        {
          title: 'Оплачиваемый отпуск каждый год.',
          desc: 'Каждый год самые активные танцовщицы — особенно те, кто стабильно взаимодействует с фанатами — получат вознаграждение в виде оплачиваемого отпуска.',
        },
        {
          title: 'Реальный голос в платформе.',
          desc: 'Мы ценим любые предложения — именно поэтому у нас более тысячи танцовщиц-исполнительниц в роли инвесторов, чтобы слушать и оставаться на связи с тем, что действительно важно.',
        },
        {
          title: 'Реальная сцена в главном шоуруме.',
          desc: 'В отличие от других сайтов, у нас будет главный шоурум, где танцовщицы получают 15–20 минут реального живого выступления на сцене. Это даёт клиентам возможность увидеть вас в действии и привлекает их на вашу страницу и в ваши приватные настройки, повышая вовлечённость и количество подписчиков.',
        },
      ],
      closing:
        'Это не правила — это ритм платформы. Когда танцовщицы выходят, вся сцена загорается.',
      footerTag: 'danceforfans.com · Сценический контракт',
    },
    vision: {
      p1: 'Dance for Fans — это развивающаяся платформа для взрослых 18+, посвящённая чувственному и выразительному танцу. Она идеально подходит для пар — представьте пары в стиле dirty dancing — а также для одиноких мужчин и женщин, желающих поделиться своим искусством. Мы также с гордостью приветствуем ЛГБТК+ сообщество.',
      p2: 'У Dance for Fans будет главный зал, где каждый танцор записывается в лист ожидания, чтобы получить возможность выйти на главную сцену. Пары, соло-исполнители и все артисты получают шанс выступить вживую, что помогает им найти клиентов и фанатов, которые откликаются им и следуют за ними на их частные страницы.',
      p3Start:
        'Это развлечение для взрослых, которое прославляет смелую креативность, интимность и связь, давая исполнителям возможность сиять и привлекать фанатов, ценящих их работу.',
      p3Highlight: '',
    },
    sections: {
      title: 'Две сцены. Одно сообщество.',
      subtitle:
        'Мы стремимся расширять возможности авторов любого происхождения. Вот почему мы предусматриваем два отдельных раздела, гарантируя, что каждый исполнитель найдет нужную аудиторию.',
      openFloor: {
        title: 'Открытая площадка',
        desc: 'Для создателей танцев в целом и всех стилей. Пространство, посвященное искусству движения, от контемпорари до хип-хопа, от балета до брейк-данса.',
        bullets: [
          'Приветствуются все возрасты',
          'Гибкие инструменты монетизации',
          'Поддерживающее сообщество',
        ],
      },
      afterHours: {
        tag: 'ТОЛЬКО 18+',
        title: 'После закрытия',
        desc: 'Для тех, кто исследует контент для взрослых. Элегантная и безопасная среда, гарантирующая, что исполнители найдут нужную аудиторию для более зрелых форм самовыражения.',
        bullets: [
          'Среда с возрастным ограничением',
          'Премиальная монетизация',
          'Конфиденциально и безопасно',
        ],
      },
    },
    join: {
      tag: 'Присоединяйтесь с самого начала',
      title: 'Хотите попасть в Dance for Fans?',
      subtitle:
        'Если вы хотите присоединиться с самого начала, оставьте свои данные ниже, и мы свяжемся с вами.',
      q1: 'Какой ваш Instagram?',
      q2: 'Ваш возраст? (18+)',
      q3: 'Ваш опыт в создании контента?',
      q3Placeholder: 'Расскажите о своём опыте, платформах, стиле…',
      q4: 'Сколько у вас подписчиков на всех платформах?',
      q4Placeholder: 'напр. 12k в IG, 3k в TikTok',
      q5: 'Лучший способ связаться с вами и любые ваши вопросы — здесь.',
      q5Placeholder: 'Что сделало бы эту платформу хитом?',
      btn: 'Нажмите здесь',
    },
    domain: {
      title: 'Формируйте будущее.',
      descStart:
        'Эта концепция все еще находится в процессе обдумывания. Её дом — ',
      descHighlight: 'danceforfans.com',
      descEnd: '.',
      directContact: 'Прямой контакт',
      askForStart: 'Напишите нам на ',
      askForHighlight: 'jose@danceforfans.com',
      askForEnd: ' для обсуждения приобретения этого домена и концепции.',
    },
    visit: {
      counting: 'Подсчет визитов…',
      visits: 'визитов',
    },
    launchPage: {
      headerTag: 'Закулисье',
      heroTag: '✦ Бархатный занавес · Пропуск за кулисы ✦',
      heroTitleStart: 'Как запустить платформу вроде ',
      heroTitleHighlight: 'Dance for Fans',
      heroTitleEnd: '.',
      heroDesc:
        'Добро пожаловать за кулисы. Прежде чем зажгутся прожекторы, каждому великому шоу нужна структура — энергия, освещение, безопасность, сцена, которая не прогнется, когда придет толпа. Вот что для этого нужно.',
      intro1:
        'Для хостинга вам понадобится провайдер, способный обрабатывать большие загрузки файлов, безопасные платежи и высокий трафик.',
      intro2:
        'Давайте углубимся в детали — вот лучшие варианты для такой операции.',
      providers: [
        {
          name: 'Amazon Web Services (AWS)',
          tag: 'Самый гибкий · Рекомендуется',
          desc: 'Высокомасштабируемый с такими сервисами, как EC2 для размещения вашего приложения, S3 для хранения медиафайлов и CloudFront в качестве CDN. AWS также предлагает отличные функции безопасности и инструменты соответствия.',
          bullets: [
            'Вычисления EC2 и автомасштабирование',
            'S3 для хранения медиа',
            'CDN CloudFront',
            'Инструменты IAM, KMS и соответствия',
          ],
        },
        {
          name: 'Google Cloud Platform (GCP)',
          tag: 'Самый гибкий · Рекомендуется',
          desc: 'Аналогичен AWS по масштабу и возможностям — безопасное хранение, мощные вычисления, аналитика мирового класса и бесшовная интеграция с остальной экосистемой Google.',
          bullets: [
            'Cloud Storage и Compute Engine',
            'Мощная аналитика (BigQuery)',
            'Глобальная CDN',
            'Готовность к ML/AI',
          ],
        },
        {
          name: 'Microsoft Azure',
          tag: 'Корпоративный уровень',
          desc: 'Мощный, с безопасностью корпоративного уровня, глубокими функциями соответствия и глобальными центрами обработки данных для производительности с низкой задержкой по всему миру.',
          bullets: [
            'Корпоративное соответствие',
            'Глобальные центры обработки данных',
            'Поддержка гибридного облака',
            'Надежные инструменты идентификации',
          ],
        },
        {
          name: 'DigitalOcean',
          tag: 'Легко начать',
          desc: 'Проще и понятнее — отлично подходит для небольших проектов, которым нужно пространство для масштабирования позже. Управляемые базы данных, хранилище и легко развертываемые серверы.',
          bullets: [
            'Управляемые базы данных',
            'Объектное хранилище Spaces',
            'Предсказуемые цены',
            'Удобный для разработчиков UX',
          ],
        },
        {
          name: 'Vultr / Linode',
          tag: 'Экономичный VPS',
          desc: 'Высокопроизводительные виртуальные частные серверы. Экономичны и отлично подходят, если вы хотите больше контроля и не против управлять инфраструктурой самостоятельно.',
          bullets: [
            'Дешевый, быстрый VPS',
            'Глобальные регионы',
            'Полный root-контроль',
            'Хорошо для небольших команд',
          ],
        },
      ],
      bottomTag: 'Итог',
      bottomTitleStart:
        'Для проекта вроде Dance for Fans — с большим количеством медиа и высоким трафиком — ',
      bottomTitleHighlight: 'AWS или GCP',
      bottomTitleEnd:
        ' являются наиболее гибкими и масштабируемыми вариантами.',
      bottomDesc:
        'Они дают вам пространство для роста со всеми необходимыми инструментами: хранилищем, безопасностью, производительностью и даже машинным обучением, когда вы будете готовы добавить расширенные функции.',
      footerTag: 'danceforfans.com · Закулисье',
    },
    competitorsPage: {
      headerTag: 'Денежный Этаж',
      heroTag: '✦ Следуй за деньгами ✦',
      heroTitleStart: 'Конкуренты и их ',
      heroTitleHighlight: 'доходы',
      heroTitleEnd: '.',
      heroDesc:
        'Рынок реален, и цифры говорят сами за себя. Вот лидер, который создал эту категорию — и семь крупнейших имен, преследующих его.',
      incumbentTag: 'Лидер',
      incumbentSubTag: 'Лидер рынка',
      incumbentName: 'Лидер "Только для фанатов"',
      incumbentDesc:
        'OnlyFans была запущена в 2016 году как платформа подписки для создателей, чтобы делиться контентом напрямую со своими фанатами. Она пережила быстрый рост, превысив диапазон в миллиард долларов дохода к 2020 году, воспользовавшись растущей экономикой создателей и спросом на эксклюзивный контент. Этот стремительный взлет занял около четырех лет, чему способствовала ее уникальная бизнес-модель и переход к цифровым услугам напрямую потребителю.',
      incumbentRevLabel: 'Годовой доход',
      incumbentRevVal: '$1B+',
      incumbentRevSub: 'к 2020 году · всего за 4 года',
      top7Tag: 'Топ 7 Конкурентов',
      estRevLabel: 'Оцен. Доход',
      competitors: [
        {
          name: 'Patreon',
          rev: '~$160M / год',
          desc: 'Один из крупнейших конкурентов, ориентированный на подписки создателей по всем видам контента.',
        },
        {
          name: 'Fansly',
          rev: '~$50M – $100M / год',
          desc: 'Быстро растет, и, по оценкам, приносит от пятидесяти до ста миллионов в год.',
        },
        {
          name: 'FanCentro',
          rev: '~$20M – $40M / год',
          desc: 'Хорошо зарекомендовавшая себя платформа в экономике создателей, оцениваемая примерно в двадцать-сорок миллионов ежегодно.',
        },
        {
          name: 'AVN Stars',
          rev: '~$10M – $20M / год',
          desc: 'Связанная с брендом AVN, вероятно, приносит около десяти-двадцати миллионов в год.',
        },
        {
          name: 'JustFor.Fans',
          rev: '~$5M – $15M / год',
          desc: 'Нишевая платформа, оцениваемая примерно в пять-пятнадцать миллионов ежегодно.',
        },
        {
          name: 'Unlockd',
          rev: '~$3M – $10M / год',
          desc: 'Более новый игрок в пространстве, оцениваемый примерно в три-десять миллионов в год.',
        },
        {
          name: 'IsMyGirl',
          rev: '~$2M – $5M / год',
          desc: 'Меньшая, но все же заметная в нише — оценивается примерно в два-пять миллионов ежегодно.',
        },
      ],
      bottomTag: 'Итог',
      bottomTitleStart: 'Категория стоимостью в ',
      bottomTitleHighlight: 'миллиарды',
      bottomTitleEnd:
        ' — и только вторые места зарабатывают сотни миллионов в год.',
      bottomDescStart: '',
      bottomDescHighlight: 'Dance for Fans',
      bottomDescEnd:
        ' выходит на этот рынок с более четкой идентичностью, преданной аудиторией и явным пространством для роста.',
      footerTag: 'danceforfans.com · Денежный Этаж',
    },
    storyPage: {
      headerTag: 'Архив',
      heroTag: 'Глава нулевая',
      heroTitleStart: 'От нуля до ',
      heroTitleHighlight: 'миллиардов',
      heroTitleEnd: '.',
      heroDescStart: 'Всего за ',
      heroDescHighlight: '10 лет',
      heroDescEnd:
        ' OnlyFans прошла путь от кредита в £10,000 до глобального феномена экономики создателей. Вот как.',
      chapters: [
        {
          year: '2016',
          title: 'Ставка при поддержке семьи.',
          body: 'Основатель платформы Тим Стокли запустил сайт при первоначальной поддержке своей семьи. По сообщениям, он одолжил около £10,000 у своего отца, Гая Стокли, чтобы запустить сайт. Это первоначальное финансирование покрыло расходы на разработку и ранний маркетинг, позволив платформе медленно привлечь свою первую волну создателей контента — тихое начало того, что станет бизнесом, определяющим категорию.',
        },
        {
          year: '2017 – 2018',
          title: 'Импульс и контрольный пакет акций.',
          body: 'К 2017 и 2018 годам платформа начала набирать реальный оборот. Она привлекла влиятельных лиц из различных отраслей, и ее модель подписки нашла отклик у создателей, ищущих прямую монетизацию. В 2018 году Леонид Радвинский — известный своим опытом работы с платформами развлечений для взрослых — приобрел 75% акций компании. Его участие принесло значительные инвестиции и деловую хватку, помогая профессионализировать операции и расширить охват.',
        },
        {
          year: '2019 – 2021',
          title: 'Взрыв.',
          body: 'С 2019 года платформа резко возросла в популярности. База создателей диверсифицировалась — влиятельные лица, музыканты, фитнес-тренеры и артисты для взрослых стекались на нее. Пандемия COVID-19 еще больше ускорила ее рост, поскольку многие создатели обратились к онлайн-платформам за доходом. К 2020 и 2021 годам она стала глобальным феноменом с миллионами пользователей и миллиардами выплат создателям.',
        },
      ],
      summaryTag: 'Вкратце',
      summaryText:
        'Это началось как смелое предприятие при поддержке семьи в 2016 году, неуклонно росло благодаря ключевым инвестициям к 2018 году, а затем взлетело до глобальной державы к 2020 году — революционизировав монетизацию создателей и переопределив модели подписки на цифровой контент по всему миру.',
      footerTag: 'danceforfans.com · Архив',
    },
    investorsPage: {
      headerTag: 'Этаж Инвесторов',
      heroTag: '✦ Уникальная возможность ✦',
      heroTitleStart: 'Владейте частью ',
      heroTitleHighlight: 'Dance for Fans',
      heroTitleEnd: '.',
      p1: 'Добро пожаловать, инвесторы! Dance for Fans предлагает уникальную возможность владеть частью нашей платформы. Мы продаем 49% компании.',
      twoPathsTitle: 'Два пути к владению.',
      p2: 'Мы рассматриваем два пути. Вариант один: несколько крупных инвесторов, каждый владеет большой долей. Вариант два: 1 000 женщин — танцовщиц или сторонниц — каждая инвестирует $2 500.',
      option1Tag: 'Путь 1',
      option1Title: 'Несколько крупных инвесторов.',
      option1Desc:
        'Небольшая группа стратегических партнеров, каждый владеет значительной долей компании. Быстрее закрыть, меньше голосов за столом.',
      option2Tag: 'Путь 2 · Рекомендуется',
      option2Title: '1 000 женщин × $2 500.',
      option2Desc:
        'Модель, основанная на сообществе — 1 000 танцовщиц или сторонниц, каждая инвестирует $2 500. Встроенные сторонники, общая выгода, широкое владение.',
      mathTag: 'Математика',
      mathTitle: 'Как складываются цифры.',
      stat1: 'Инвесторов по $2 500 каждый',
      stat2: 'Размер вклада инвестора',
      stat3: 'Общая собранная сумма',
      stat4: 'Предлагаемый капитал',
      p3: 'Во второй модели, если 1 000 женщин инвестируют по $2 500 каждая, это принесет $2,5 миллиона в общей сложности. Эти $2,5 миллиона представляют полную долю владения в 49%.',
      p4Start: 'Каждый инвестор будет владеть примерно ',
      p4Highlight: '0,049%',
      p4End: ' всей компании.',
      upsideTag: 'Потенциал',
      upsideTitle: 'Куда могут вырасти цифры.',
      projMonthlyRevLabel: 'Ежемесячный доход компании',
      projInvestorShareLabel: 'Доля инвестора 49%',
      projPerInvestorLabel: 'На одного инвестора',
      projPerInvestorSub: 'в месяц · доля 0,049%',
      p5: 'Если компания вырастет до $20 миллионов дохода в месяц, эти 49% будут равны $9,8 миллионам ежемесячно. Доля каждого инвестора потенциально может приносить около $9 800 в месяц.',
      bigUpsideTag: 'А если масштаб вырастет ещё больше',
      bigUpsideP:
        'Мы уже видели, как быстро OnlyFans выросла до $166 миллионов в месяц менее чем за четыре года. А теперь посмотрите на математику: когда Dance for Fans достигнет этого уровня, 49% для инвесторов — это около $81,3 миллиона в месяц. При 1 000 инвесторах это примерно $81 300 в месяц на каждого. Вот сила этой модели.',
      whyOption2Tag: 'Почему вариант два',
      whyOption2Title: 'Почему вариант два — самый сильный выбор',
      whyOption2Subtitle: 'Танцовщицы как инвесторы. Инвесторы как танцовщицы.',
      whyOption2Intro1:
        'Вариант два выделяется тем, что превращает людей, которые движут платформой, в настоящих партнёров её успеха. Вместо того чтобы просто пользоваться платформой, танцовщицы вкладываются в её строительство, рост и продвижение. Это создаёт гораздо более глубокий уровень лояльности, причастности и долгосрочной приверженности, чем когда-либо могла бы традиционная модель.',
      whyOption2Intro2:
        'Когда у создательниц есть доля в бизнесе, их мышление меняется. Они больше не просто участницы — они становятся послами, защитницами и движущей силой роста. Такая согласованность невероятно сильна.',
      whyOption2GrowthHeader: 'Встроенный двигатель более быстрого роста',
      whyOption2GrowthP1:
        'Достижение крупных вех дохода, включая путь к $20 миллионам в месяц, становится гораздо более достижимым, когда база инвесторов и база создательниц — это одни и те же люди. Почему? Потому что люди, зарабатывающие на платформе, теперь имеют прямой стимул помогать её расширять.',
      whyOption2GrowthLead: 'Они мотивированы:',
      whyOption2GrowthBullets: [
        'Создавать больше',
        'Продвигать больше',
        'Приводить других',
        'Активно помогать строить сообщество',
      ],
      whyOption2GrowthP2:
        'Это создаёт сетевой эффект, который может резко ускорить рост. Вместо того чтобы полагаться только на внешний маркетинг или пассивных пользователей, вариант два строит сообщество партнёров, которые финансово и эмоционально вложены в успех платформы.',
      whyOption2ProvenHeader: 'Модель доказана',
      whyOption2ProvenP:
        'Мы уже видели, как быстро могут масштабироваться платформы, движимые создательницами, когда есть правильный импульс. Платформа подписки для фанатов OnlyFans достигла огромного месячного дохода всего за несколько коротких лет, потому что создательницы подпитывали и привлечение, и удержание. Тот же тип импульса может быть ещё более мощным здесь, когда создательницы не только зарабатывают на платформе, но и участвуют в её росте.',
      whyOption2MattersHeader: 'Почему это важно',
      whyOption2MattersP1:
        'Вариант два — это не просто стратегия финансирования, это стратегия роста. Он создаёт более крепкую лояльность, более быстрое расширение и сообщество, мотивированное побеждать вместе.',
      whyOption2MattersP2:
        'Именно это делает вариант два лучшим выбором: он согласует владение с вкладом и превращает рост в общую миссию.',
      disclaimer:
        'Эти цифры являются иллюстративными прогнозами, предназначенными для демонстрации финансового потенциала модели. Фактические результаты будут зависеть от производительности платформы, рыночных условий и многих других факторов. Это не является предложением о продаже ценных бумаг.',
      contactBtn: 'Написать на jose@danceforfans.com',
      footerTag: 'danceforfans.com · Этаж Инвесторов',
    },
  },
}
